import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import PrimaryButton from '../../jsx/components/button/primaryButton'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { callTrue, notificationReduxState, setCurrentPage, setDownloadAppBar, setNotificationCount, updateBackDropLoaderWithoutStateFalse } from '../../feature/userData/userData';
import InputField from '../../jsx/components/fields/inputField';
import TextArea from '../../jsx/components/fields/textArea';
import { Modal, OverlayTrigger, Popover, Spinner } from 'react-bootstrap';
import { ImageCropper } from './ImageCropper';
import RecogObj from '../../service/api/recognition/captureAndRecognize';
import html2canvas from 'html2canvas';
import ImagePreviewer from '../../jsx/components/imagePreviewer/imagePreviewer';
import imageCompression from 'browser-image-compression';
import { createUpdateProjectApi } from '../../service/api/ticket/createUpdateProject';
import SkeletonDivElement from '../../component/skeletonTableRow/skeletonDivElement';
import { getAISuggestionsApi } from '../../service/api/object/getAISuggestions';
import { IoIosQrScanner } from 'react-icons/io';
import { MdChecklistRtl, MdDraw, MdOutlineCameraAlt, MdOutlineLock } from 'react-icons/md';
import { CgNotes } from 'react-icons/cg';
import { saveProjectSuggestionsApi } from '../../service/api/ticket/saveProjectSuggestions';
import { getSavedProjectSuggestionsApi } from '../../service/api/ticket/getSavedProjectSuggestions';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import deleteProjectSuggestionApi from '../../service/api/ticket/deleteProjectSuggestion';
import { emailValidation, noSpaceOnChange, phoneValidation, urlPattern } from "../../validations/validation";
import emptyListImg from '../../media/images/servicesAssets/emptyListImg.png'
import { createPurchaseItem } from '../../service/api/ticket/createPurchaseItem';
import updatePurchaseItem from '../../service/api/ticket/updatePurchaseItem';
import deletePurchaseItem from '../../service/api/ticket/deletePurchaseItem';
import { getProjectsApi } from '../../service/api/ticket/getProjects';
import deleteProjectDetailApi from '../../service/api/ticket/deleteProjectDetail';
import { getProjectDetailApi } from '../../service/api/ticket/getProjectDetail';
import { callNote } from '../../service/api/callHistory/callNote';
import { deleteCallLogNoteById } from '../../service/api/callHistory/deleteCallLogNoteById';
import { TbMessage2, TbRulerMeasure } from 'react-icons/tb';
import ocr from '../../service/api/recognition/ocr';
import DrawingDemo from '../moreTabs/drawingDemo';
import Scan from '../scan/scan';
import RangeInput from '../../jsx/components/fields/rangeInput';
import { callNoteDetails } from '../../service/api/callHistory/callNoteDetails';
import logo from "../../icons/photos/chillLogo.png";
import { bulkDeleteProjectStepsApi } from '../../service/api/ticket/bulkDeleteProjectSteps';
import DefineProjectImage from '../../media/images/DIYAssets/DefineProjectImage.jpeg';
import DocumentDIYProjectImage from '../../media/images/DIYAssets/DocumentDIYProjectImage.jpeg';
import EnhancePlanDIYProject from '../../media/images/DIYAssets/EnhancePlanDIYProject.jpeg';
import updateCallNoteApi from '../../service/api/callHistory/updateCallNote';
import skillSummaryImg from "../../media/images/DIYAssets/skillSummaryImg.png";
import costTimeImg from "../../media/images/DIYAssets/costTimeImg.png";
import toolsImg from "../../media/images/DIYAssets/toolsImg.png";
import captureBeforeImg from "../../media/images/DIYAssets/captureBeforeImg.jpeg";
import { IoSend } from "react-icons/io5";
import { getChatHistoryApi } from '../../service/api/ticket/getChatHistory';
import createUpdateChatHistoryApi from '../../service/api/ticket/createUpdateChatHistory';
import deleteProjectChatHistoryApi from '../../service/api/ticket/deleteProjectChatHistory';
import { RiCloseFill, } from "react-icons/ri";
import { CiCamera } from "react-icons/ci";
import { LuSend } from "react-icons/lu";
import { FiMessageCircle } from "react-icons/fi";

// ------------------
import './newScanFlow.scss'
import { getCat } from '../../service/api/object/getCat';
import { getProductType } from '../../service/api/object/getProdType';
import unavailbleServiceImg from '../../media/images/servicesAssets/unavailbleServiceImg.png'
import DummyBackdropLoader from '../../component/backDrop/dummyBackDropLoader';
import CreateTicket from '../../service/api/ticket/createTicket';
import serviceImg from '../../media/images/serviceImg.gif'
import {
    backDropLoaderRejectedCaseRedux,
    backLoaderFalse,
    backLoaderTrue,
    setLoaderTime,
    setUserDetails,
    updateServiceReqModalFalse,
} from "../../feature/userData/userData";
import BackDropLoaderRejectedCase from '../../component/backDrop/backDropLoaderRejectedCase';
import BackDrop from '../../component/backDrop/backDropLoader';
import UpdateServiceRequest from '../../component/updateServiceRequest/updateServiceRequest';
import ErrorBackdropLoader from '../../component/backDrop/errorBackDropLoader';
import SelectInputTimeSlot from '../../jsx/components/fields/selectInputTimeSlot';
import updateTicketDetail from '../../service/api/ticket/updateTicketDetail';
import deleteTicketByIdApi from '../../service/api/ticket/deleteTicketById';
import updateTicketStatus from '../../service/api/ticket/updateTicketStatus';
import io from "socket.io-client";
import { unreadNotificationCount } from '../../service/api/notification/unreadNotification';
import { btnResendCode, btnVerify, errEmptyEmailOrPhone, hintEnterValidationCode, lblFirstName, passwordLengthText, txtMobileNumber, validEmail_OR_MobileNumberText } from '../../dataBaseFile/label';
import EmailPhoneCombine from '../../jsx/components/fields/emailPhoneField';
import { confirmPasswordValidation, firstNameValidation, passwordValidation, phoneOnChange } from '../../functions/validations';
import { enterFirstName, validFirstName, validPassword } from '../../dataBaseFile/error';
import guestHomeownerForumApi from '../../service/api/guestUsers/guestHomeownerForum';
import { FaCheck } from 'react-icons/fa6';
import { PiBellRingingBold } from "react-icons/pi";
import { signUp } from '../../service/api/user/signUp';
import { activateUser } from '../../service/api/user/activationCode';
import { resendCode } from '../../service/api/user/resendActivationCode';


function buildProblemDescription(userNotes, agentLinkAnswers) {
    const userPart = userNotes?.trim() || "";
    const rows = Array.isArray(agentLinkAnswers) ? agentLinkAnswers : [];
    const lines = rows
        .filter((r) => r?.answer)
        .map((r) => `${r.prompt}: ${r.answer}`);
    if (!lines.length) return userPart;
    const block = ["— Agent link —", ...lines].join("\n");
    if (!userPart) return block;
    return `${userPart}\n\n${block}`;
}

const UNKNOWN_DEVICE_TYPE_ID = -2;
const UNKNOWN_DEVICE_DISPLAY_NAME = "Enter device type";

function getProductTypeDisplayName(item) {
    if (!item) return "";
    if (item.product_type_id_ids === UNKNOWN_DEVICE_TYPE_ID) {
        return UNKNOWN_DEVICE_DISPLAY_NAME;
    }
    return item.product_type_name_chr || "";
}

function normalizeProductTypeItem(item) {
    if (!item || item.product_type_id_ids !== UNKNOWN_DEVICE_TYPE_ID) {
        return item;
    }
    return { ...item, product_type_name_chr: UNKNOWN_DEVICE_DISPLAY_NAME };
}

function normalizeProductTypeList(list) {
    if (!Array.isArray(list)) return list;
    return list.map(normalizeProductTypeItem);
}



const Estimate = ({
    DIYProjectId = "",
    DIYProjectDescription = "",
}) => {

    const {
        // role,
        backDropLoaderStatus,
        updateServiceRequestStatus,
        backDropLoaderRejectedCase,
        paymentMethodID,
        customerID,
        impersonateFlag,
        permissionArr,
        totalCreditsInCents,
        callStatus,
    } = useSelector((state) => state.user);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const agentLinkSeededRef = useRef(false);

    const [scanSteps, setScanSteps] = useState(0.1);

    const [catArr, setCatArr] = useState([]);

    const [recognizeImageLoading, setRecognizeImageLoading] = useState(false);

    const [resValue, setResValue] = useState("");
    const [objectCategoryName, setObjectCategoryName] = useState('');
    const [predictionFlag, setPredictionFlag] = useState(false);
    const [predictedObjectClassId, setPredictedObjectClassId] = useState();
    const [predictedObjectClassName, setPredictedObjectClassName] = useState();
    const [productTypeDetected, setProductTypeDetected] = useState("");
    const [predictedLogId, setPredictedLogId] = useState();
    const [productTypeList, setProductTypeList] = useState([]);
    const [deviceBrandChr, setDeviceBrandChr] = useState();
    const [deviceColorChr, setDeviceColorChr] = useState();
    const [modelNum, setModelNum] = useState("");
    const [serialNumber, setSerialNumber] = useState("");
    const [objectCondition, setObjectCondition] = useState('');
    const [predictedObjectDetails, setPredictedObjectDetails] = useState({})
    const [particularID, setParticularID] = useState();
    const [productTypeResp, setProductTypeResp] = useState(false);
    const [productNameForTicket, setProductNameForTicket] = useState("");
    const [catId, setCatId] = useState();
    const [breadCatButtonName, setBreadCatButtonName] = useState();
    const [prodTypeId, setProdTypeId] = useState();

    const [isEditingBrand, setIsEditingBrand] = useState(false);
    const [isEditingModel, setIsEditingModel] = useState(false);

    const [categoryObj, setCategoryObj] = useState({});
    const [productTypeObj, setProductTypeObj] = useState({});

    const [categoryErr, setCategoryErr] = useState(false);
    const [productTypeErr, setProductTypeErr] = useState(false);

    const [toggleForSelectCategory, setToggleForSelectCategory] = useState(false);
    const [toggleForSelectProductType, setToggleForSelectProductType] = useState(false);

    const [description, setDescription] = useState("");
    const [agentLinkAnswers, setAgentLinkAnswers] = useState([]);



    const problemDescription = useMemo(
        () => buildProblemDescription(description, agentLinkAnswers),
        [description, agentLinkAnswers]
    );

    const fromAgentLink = useMemo(
        () => agentLinkAnswers.some((r) => r?.answer),
        [agentLinkAnswers]
    );

    const showAgentLinkCaptureIntro =
        fromAgentLink && (scanSteps === 1.1 || scanSteps === 1.2);

    const [finalAmountAfterPromoCodeApplied, setFinalAmountAfterPromoCodeApplied] = useState(0);
    const [isCreditsUsed, setIsCreditsUsed] = useState(false);
    const [verifiedPromoCode, setVerifiedPromoCode] = useState("");
    const [qrResult, setQrResult] = useState("");

    const [backDropLoaderResp, setBackDropLoaderResp] = useState(false);

    const [serviceSearchProFlag, setServiceSearchProFlag] = useState();

    const [timeSlotArr, setTimeSlotArr] = useState([]);
    const [comminicationModeArr, setCommunicationModeArr] = useState([]);

    const [responseAfterSubmit, setResponseAfterSubmit] = useState("");
    const [errBackDropLoaderResp, setErrBackDropLoaderResp] = useState(false);

    const [paymentGatewayFlag, setPaymentGatewayFlag] = useState(0);

    const [serviceActionModalTrigger, setServiceActionModalTrigger] = useState(false);
    const [serviceRequestSelectedOption, setServiceRequestSelectedOption] = useState("1");
    const [serviceRequestModalTabs, setServiceRequestModalTabs] = useState(1);

    const [currentDate, setCurrentDate] = useState(new Date().toISOString().split('T')[0]);
    const [timeSlotCheck, setTimeSlotCheck] = useState(false);
    const [communicationModeCheck, setCommunicationModeCheck] = useState(false);
    const [timeSlotID, setTimeSlotID] = useState(4);
    const [communicationModeID, setCommunicationModeID] = useState(3);
    const [saveUpdateTicketLoading, setSaveUpdateTicketLoading] = useState(false);

    const [deleteServiceReqLoading, setDeleteServiceReqLoading] = useState(false);
    const [loadingForCancelRequest, setLoadingForCancelRequest] = useState(false);

    const [toggleForCatSelect, setToggleForCatSelect] = useState(1);

    const [guestUserId, setGuestUserId] = useState("");

    const socketRef = useRef(null); // Initialize socketRef using useRef()

    const [firstName, setFirstName] = useState("");
    const [isFirstNameError, setIsFirstNameError] = useState(false);
    const [errorFirstNameMsg, setErrorFirstNameMsg] = useState("");
    const [messageText, setMessageText] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
    const [emailPhoneValue, setEmailPhoneValue] = useState("");
    const [codeValue, setCodeValue] = useState(1);
    const [isPhone, setIsPhone] = useState(false);
    const [loginErrorMsg, setLoginErrorMsg] = useState("");

    const [recievedCodeValue, setRecievedCodeValue] = useState("");
    const [isCodeError, setIsCodeError] = useState(false);

    const [resendCodeTimer, setResendCodeTimer] = useState(60);
    const [resendCodeCheck, setResendCodeCheck] = useState(true);

    const resendCodeActivation = () => {
        if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {
            let formData = new FormData();
            formData.append(
                "phone_code_id_int",
                parseInt(localStorage.getItem("countryCodeVal"))
            );
            formData.append(
                "phone_number_int",
                parseInt(localStorage.getItem("emailPhoneVal"))
            );
            formData.append("email_chr", "");

            dispatch(
                resendCode(
                    formData,
                    (res) => {
                        setResponceMsg(res.data.message);
                        setToasterType("success");
                        setHandleToaster(true);

                        setResendCodeCheck(true);
                        setResendCodeTimer(60);

                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    },
                    (err) => {
                        setResponceMsg(err.data.message);
                        setToasterType("error");
                        setHandleToaster(true);

                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                )
            );
        } else if (emailValidation(localStorage.getItem("emailPhoneVal"))) {
            let formData = new FormData();
            formData.append("phone_code_id_int", 0);
            formData.append("phone_number_int", 0);
            formData.append("email_chr", localStorage.getItem("emailPhoneVal"));

            dispatch(
                resendCode(
                    formData,
                    (res) => {
                        setResponceMsg(res.data.message);
                        setToasterType("success");
                        setHandleToaster(true);

                        setResendCodeCheck(true);
                        setResendCodeTimer(60);

                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    },
                    (err) => {
                        setResponceMsg(err.data.message);
                        setToasterType("error");
                        setHandleToaster(true);

                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                )
            );
        }
    };

    const intervalId = useRef(null);

    useEffect(() => {
        if (localStorage.getItem("emailPhoneVal")) {
            if (emailValidation(localStorage.getItem("emailPhoneVal"))) {
                setIsPhone(false);
            } else if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {
                setIsPhone(true);
            }
            if (resendCodeCheck && resendCodeTimer > 0) {
                intervalId.current = setInterval(
                    () => setResendCodeTimer((prev) => prev - 1),
                    1000
                );
            } else if (!resendCodeCheck || resendCodeTimer === 0) {
                clearInterval(intervalId.current);
            }

            if (resendCodeTimer === 0) {
                setResendCodeCheck(false);
            }
            return () => clearInterval(intervalId.current);
        }

    }, [resendCodeCheck, resendCodeTimer]);

    function handleValidateCode(e) {
        setIsCodeError(false);
        setRecievedCodeValue(e.target.value);
    }

    const handleEmailPhone = (e) => {
        setIsEmailPhoneVal(false);

        // validation for the both email and phone
        noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);

        // Validation for the phone number only
        // phoneOnChange(e.target.value) && setEmailPhoneValue(e.target.value);
    };
    const handleDropdownValue = (e) => {
        // setCodeValue(e.target.value);
        setCodeValue(e);
    };

    useEffect(() => {
        const dot = ".";
        const leng = emailPhoneValue.length - 1;
        if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
            if (emailPhoneValue.length < 11) {
                setIsPhone(true);
            } else {
                setIsPhone(false);
            }
        } else {
            setIsPhone(false);
        }
        if (emailPhoneValue === "") {
            setIsPhone(false);
        }
    }, [emailPhoneValue]);

    function handleEmailPhoneBlur() {
        if (isPhone) {
            if (!phoneValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
            }
        } else {
            if (!emailValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
            }
        }
    }

    const handleFirstName = (e) => {
        setIsFirstNameError(false);
        setFirstName(e.target.value);
    };

    const handleMessageText = (e) => {
        setMessageText(e.target.value);
    }

    const deleteServiceReqFunc = () => {
        setDeleteServiceReqLoading(true);

        let details = {
            ticket_id_ids: localStorage.getItem("ticket_id"),
        };

        dispatch(deleteTicketByIdApi(details, (res) => {
            setResponceMsg(res.data.message);
            setDeleteServiceReqLoading(false);
            // dispatch(backLoaderFalse());
            // navigate('/');
            setServiceRequestModalTabs(6);
        }), (res) => {
            setDeleteServiceReqLoading(false);

            setResponceMsg(res.data.message);
            setToasterType("error")

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        })
    }

    const cancelRequest = () => {
        setLoadingForCancelRequest(true);
        let formData = new FormData();

        formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        formData.append("ticket_status_ysn", 7);

        dispatch(updateTicketStatus(formData, (res) => {

            setLoadingForCancelRequest(false);
            // dispatch(backLoaderFalse());
            navigate('/serviceRequestDetails');
        }), (res) => {
            setLoadingForCancelRequest(false);

            setResponceMsg(res.data.message);
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        })
    }



    function updateTimeSlotFn(e) {
        setTimeSlotCheck(false);
        setTimeSlotID(e.target.value);
    }


    const handleOpenServiceActionModal = () => setServiceActionModalTrigger(true);
    const handleCloseServiceActionModal = () => setServiceActionModalTrigger(false);

    const handleServiceRequestActions = () => {
        if (serviceRequestSelectedOption == 1) {
            setServiceRequestModalTabs(2);
        } else if (serviceRequestSelectedOption == 2) {
            setServiceRequestModalTabs(3);
        } else if (serviceRequestSelectedOption == 3) {
            setServiceRequestModalTabs(5);
        }
    }

    const [currentTime, setCurrentTime] = useState("");

    const handleSetCurrentDateAndTime = () => {
        // Get the current date and time
        const now = new Date();
        const date = now.toISOString().split('T')[0]; // format yyyy-mm-dd for the date input

        // Set the time one hour ahead
        now.setHours(now.getHours() + 1);

        let hours = now.getHours();
        let minutes = now.getMinutes();

        // Adjust minutes to the nearest 30-minute slot
        minutes = minutes < 30 ? 0 : 30;

        // If minutes round up to 0 and it causes the hour to increase (e.g., 23:59 -> 00:00)
        if (minutes === 0 && now.getMinutes() >= 30) {
            hours += 1;
        }

        // Ensure two-digit formatting for hours and minutes
        hours = hours < 10 ? `0${hours}` : hours;
        minutes = minutes === 0 ? `00` : `30`;

        const time = `${hours}:${minutes}`;

        // Update the state
        setCurrentDate(date);
        setCurrentTime(time);
    };

    const convertToUnixTime = () => {
        // Combine the date and time into a single Date object
        const combinedDateTime = new Date(`${currentDate}T${currentTime}`);
        // Convert to Unix timestamp
        return Math.floor(combinedDateTime.getTime() / 1000);
    };

    const calculateEndTime = (unixTime) => {
        // Adding 3600 seconds (1 hour) to the current unix timestamp
        return unixTime + 3600;
    };

    function updateServiceRequestFn(e) {
        e.preventDefault();
        const unixTimestamp = Math.floor(new Date(currentDate).getTime() / 1000);
        // const startTimeUnix = convertToUnixTime();
        const endTimeUnix = calculateEndTime(unixTimestamp);

        if (timeSlotID === 0 && communicationModeID === 0) {
            setTimeSlotCheck(true);
            setCommunicationModeCheck(true);
            return;
        }

        if (timeSlotID === 0) {
            setTimeSlotCheck(true);
            return;
        }
        if (communicationModeID === 0) {
            setCommunicationModeCheck(true);
            return;
        }

        setSaveUpdateTicketLoading(true);



        let formData = new FormData();

        formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        formData.append("time_slot_id", parseInt(timeSlotID))
        formData.append("communication_mode_id", parseInt(communicationModeID));
        // formData.append("address_id_ids", 0);
        localStorage.getItem("proType") !== "null" && formData.append("product_type_chr", localStorage.getItem("proType") || '')
        formData.append("product_category_chr", objectCategoryName)
        modelNum && formData.append("model_number_chr", modelNum)
        problemDescription && formData.append("problem_description_chr", problemDescription);

        // No need to add attachments already uploaded
        // uploadAttachedImage1 != null && formData.append("attachment_id_ids0", "");
        // uploadAttachedImage1 != null && formData.append("attachment0", uploadAttachedImage1);
        // uploadAttachedImage2 != null && formData.append("attachment_id_ids1", "")
        // uploadAttachedImage2 != null && formData.append("attachment1", uploadAttachedImage2)
        // uploadAttachedImage2 != null && formData.append("attachment_id_ids2", 0)
        // uploadAttachedImage2 != null && formData.append("attachment2", uploadAttachedImage2)
        formData.append("unix_datetime_stamp_start", unixTimestamp);
        formData.append("unix_datetime_stamp_end", endTimeUnix);
        formData.append("is_scheduling_flag", 1);

        dispatch(updateTicketDetail(formData, (res) => {
            setResponceMsg(res.data.message);
            setSaveUpdateTicketLoading(false);
            setServiceRequestModalTabs(4);
            // setToggleUpdate(false);
            // handleClose();
            // navigate("/particularTicketDetails");
        }, (err) => {
            setSaveUpdateTicketLoading(false);
        }))

    }

    function handleDescription(e) {
        setDescription(e.target.value);
    }



    useEffect(() => {
        // getCameraStream();

        var forCatData = {
            page_index: 1,
            page_size: 25,
            sorting_order: 'ASC',
        };

        dispatch(
            getCat(forCatData, (res) => {
                setCatArr(res.data.data);
            })
        );

        dispatch(setDownloadAppBar(false));

        dispatch(setCurrentPage("Connect to pro"));

        return () => {
            stopCameraStream();
        };
    }, [])

    useEffect(() => {
        if (agentLinkSeededRef.current) return;
        const rows = location.state?.agentLinkAnswers;
        if (!Array.isArray(rows) || !rows.length) return;
        setAgentLinkAnswers(rows);
        agentLinkSeededRef.current = true;
    }, [location.state]);

    // This function currently not required but will be used
    const handleRecognizeObject = () => {
        if (!uploadAttachedImage0) {
            return;
        }

        setRecognizeImageLoading(true);

        let formData = new FormData();
        formData.append("image", uploadAttachedImage0, "scanned_image.png");

        dispatch(
            RecogObj(
                formData,
                (res) => {
                    setRecognizeImageLoading(false);


                    // setCanvasEnabled(false);
                    // setLoading(false);
                    // setResValue(res.data.message);
                    // clearValue();
                    // setIsResValue(true);
                    // setObjectCategoryName(res.data.data.predicted_object_category);
                    // setPredictionFlag(res.data.data.prediction_flag);
                    // setPredictedObjectClassId(
                    //     res.data.data.predicted_object_class_id_ids
                    // );
                    // setPredictedObjectClassName(res.data.data.predicted_object_name);
                    // setProductTypeDetected(res.data.data.predicted_object_name);
                    // setPredictedLogId(res.data.data.prediction_logs_id);
                    // setProductTypeList(res.data.data.product_type_list);

                    // setDeviceColorChr(res.data.data.device_color);
                    // setDeviceBrandChr(res.data.data.predicted_object_brand);

                    // setModelNum(res.data.data.predicted_object_model_number);
                    // setSerialNumber(res.data.data.predicted_object_serial_number);

                    // setObjectCondition(res.data.data.predicted_object_condition);

                    // setPredictedObjectDetails(res?.data?.data);

                    // handleScanSteps(3);
                },
                () => {
                    setRecognizeImageLoading(false);
                }
            )
        );
    }

    function handleSetCatId(ele) {

        setCategoryErr(false);
        setCategoryObj(ele);
        setProductTypeResp(true);
        // setProductNameForTicket(ele.category_name_chr)
        setCatId(ele.category_id_ids);
        // setBreadCatName(ele.category_name_chr + " >> ");
        setObjectCategoryName(ele.category_name_chr);
        setBreadCatButtonName(ele.category_name_chr);
        // setLabelName("Product Type");

        setProductTypeObj({});
        setProdTypeId('');
        setProductNameForTicket('');


        var data = {
            category_id_ids: ele.category_id_ids,
            page_size: 25,
        };

        dispatch(
            getProductType(
                data,
                (res) => {
                    setProductTypeResp(false);
                    // setProdTypeArr(res.data.data);
                    setProductTypeList(normalizeProductTypeList(res.data.data));
                    // setAddUnknwProdArr(res.data.extra_options);
                },
                (err) => {
                    setProductTypeResp(true);
                }
            )
        );
    }

    function handleSetProductType(ele) {
        const normalized = normalizeProductTypeItem(ele);
        setProductTypeErr(false);
        setProductTypeObj(normalized);
        setProdTypeId(normalized.product_type_id_ids);
        setProductNameForTicket(getProductTypeDisplayName(normalized));
        // setPredictedObjectClassName(
        //   res.data.data.predicted_object_name
        // );
        // setBreadProductName(ele.product_type_name_chr + " >> ");
        // setLabelName("Brand Name");
        var data = {
            product_type_id_ids: ele.product_type_id_ids,
            page_index: 1,
            page_size: 25,
        };
    }

    const handleDeviceBrandChr = (e) => {
        setDeviceBrandChr(e.target.value);
    };

    const handleModelNum = (e) => {
        setModelNum(e.target.value);
    };

    const handleSelectCategoryAndProctucType = () => {
        const selectedCategory = categoryObj;
        const selectedProductType = productTypeObj;

        if (Object.keys(selectedCategory).length === 0) {
            setCategoryErr(true);
            return;
        }

        if (Object.keys(selectedProductType).length === 0) {
            setProductTypeErr(true);
            return;
        }

        if (Object.keys(selectedCategory).length === 0 || Object.keys(selectedProductType).length === 0) {
            return;
        }

        // Proceed with the selected category and product type
        console.log("Selected Category:", selectedCategory);
        console.log("Selected Product Type:", selectedProductType);

        setScanSteps(2.2);
        setToggleForCatSelect(1);
    }

    const handleBack = () => {
        if (scanSteps == 0.1) {
            stopCameraStream();
            navigate('-1');
        } else if (scanSteps == 1.1) {
            stopCameraStream();
            setScanSteps(0.1);
            // navigate('-1');
        } else if (scanSteps == 1.2) {
            setImgSrc(null);
            getCameraStream();
            setScanSteps(1.1);

        } else if (scanSteps == 2.1) {
            if (toggleForCatSelect == 1) {
                setScanSteps(1.1);
                getCameraStream();
                deleteAttachedImage0();
                deleteAttachedImage1();
                deleteAttachedImage2();

                setCategoryObj({});
                // setProductNameForTicket('');
                setCatId('');
                // setBreadCatName(ele.category_name_chr + " >> ");
                setObjectCategoryName('');
                setBreadCatButtonName('');

                setProductTypeObj({});
                setProdTypeId('');
                setProductNameForTicket('');
            } else {
                setToggleForCatSelect(1);
            }

        } else if (scanSteps == 2.2) {
            setScanSteps(2.1);
        } else if (scanSteps == 3) {
            setScanSteps(2.2);
        } else if (scanSteps == 4) {
            setScanSteps(3);
        } else if (scanSteps == 4.1) {
            setScanSteps(4);
        }
    }



    function submitFeedback() {
        let formData = new FormData();
        let createTicketData = new FormData();

        createTicketData.append("user_id_ids", localStorage.getItem("user_id"));
        // createTicketData.append("address_id_ids",0)
        //  !predictionFlag && productNameForTicket && createTicketData.append("object_name_chr",productNameForTicket)
        // createTicketData.append("object_name_chr", productNameForTicket ? productNameForTicket : predictedObjectClassName);
        createTicketData.append(
            "object_name_chr",
            productNameForTicket ? productNameForTicket : productTypeDetected
        );

        createTicketData.append("object_category_chr", objectCategoryName);
        modelNum && createTicketData.append("object_model_number_chr", modelNum);
        serialNumber && createTicketData.append("serial_number_chr", serialNumber);
        // problemDescription &&
        //     createTicketData.append("problem_description_chr", problemDescription);
        description &&
            createTicketData.append("problem_description_chr", description);
        deviceBrandChr &&
            createTicketData.append("device_brand_chr", deviceBrandChr);
        deviceColorChr &&
            createTicketData.append("device_color_chr", deviceColorChr);
        uploadAttachedImage0 &&
            createTicketData.append(
                "attachment0",
                uploadAttachedImage0,
                "uploadAttachedImage0.jpeg"
            );
        uploadAttachedImage1 != null &&
            createTicketData.append(
                "attachment1",
                uploadAttachedImage1,
                "uploadAttachedImage1.jpeg"
            );
        uploadAttachedImage2 != null &&
            createTicketData.append(
                "attachment2",
                uploadAttachedImage2,
                "uploadAttachedImage2.jpeg"
            );
        createTicketData.append(
            "amount_after_discount",
            finalAmountAfterPromoCodeApplied
        );

        isCreditsUsed && createTicketData.append("use_credits_flag", isCreditsUsed);

        verifiedPromoCode && createTicketData.append("promo_code_applied", verifiedPromoCode);
        qrResult && createTicketData.append("qr_info_chr", qrResult);
        objectCondition && createTicketData.append("condition_chr", objectCondition);
        DIYProjectId && createTicketData.append("project_id_ids", DIYProjectId);

        // image && formData.append("image", image, "image.jpeg");
        // formData.append("object_class_id", predictedObjectClassId);
        // formData.append("prediction_logs_id", predictedLogId);
        // formData.append("object_class_name", predictedObjectClassName);
        // formData.append("feedback_flag_ysn", feedbackStart);
        // formData.append("category_id_ids", catId);

        // formData.append("product_type_id_ids", prodTypeId);
        // formData.append("brand_id_ids", brandId);
        // formData.append("object_name_chr", productName);
        // formData.append("object_model_number_chr", modelNum);
        // formData.append("object_tag_chr", tagNum);
        // formData.append("object_description_chr", description);

        // This is_free_sr is need to be check
        verifiedPromoCode && localStorage.getItem("isFreeSR") && createTicketData.append("is_free_sr", localStorage.getItem("isFreeSR") ? localStorage.getItem("isFreeSR") : 0);
        createTicketData.append("ticket_type", 1);

        let summary_meta_data = {
            recognized_image_summary: predictedObjectDetails?.predicted_object_info?.recognized_image_summary || '',
            recognized_estimation_summary: predictedObjectDetails?.predicted_object_info?.recognized_estimation_summary || '',
            recognized_repair_and_install_summary: predictedObjectDetails?.predicted_object_info?.recognized_repair_and_install_summary || '',
            is_estimations_call: 1,
        }
        createTicketData.append("summary", JSON.stringify(summary_meta_data));

        setBackDropLoaderResp(true);
        dispatch(
            CreateTicket(
                createTicketData,
                (res) => {
                    setScanSteps(4);

                    // handleOpenServiceActionModal();
                    localStorage.setItem("ticket_id", res.data.data.ticket_id_ids);
                    localStorage.setItem("proType", res.data.data.product_type_chr);
                    setServiceSearchProFlag(res.data.search_pro);

                    dispatch(setLoaderTime(res.data));

                    setBackDropLoaderResp(false);
                    dispatch(backLoaderTrue());

                    localStorage.getItem("isFreeSR") && localStorage.removeItem("isFreeSR");
                    localStorage.getItem("proCode") && localStorage.removeItem("proCode");

                    setGuestUserId(res.data.data.created_by_chr);
                    localStorage.setItem("user_id", res.data.data.created_by_chr);

                    localStorage.setItem("guest_user_id", res.data.data.created_by_chr);

                    // console.log("res.data.search_pro", res.data.search_pro);

                    setTimeSlotArr(res.data.time_slot);
                    setCommunicationModeArr(res.data.communication_mode);

                    setResponseAfterSubmit(res.data.message);
                    setResponceMsg(res.data.message)
                    // handleCloseOnlyResBox();
                },
                (res) => {
                    setResponseAfterSubmit(res.data.message);
                    setResponceMsg(res.data.message)
                    setBackDropLoaderResp(false);
                    setErrBackDropLoaderResp(true);

                    setTimeout(() => {
                        setErrBackDropLoaderResp(false);
                    }, 2500);
                }
            )
        );
    }

    // Added socket code here


    useEffect(() => {
        // Initialize the socket connection
        socketRef.current = io(process.env.REACT_APP_ENV, {
            query: {
                user_id_ids: localStorage.getItem("user_id") || guestUserId || "",
                device_type_chr: "BROWSER",
            },
        });

        socketRef?.current.on("connect", () => {
            console.log("Connected to IB WebSocket");
        });

        socketRef?.current.on("message", (message) => {
            console.log("Received message: Socket", message);
        });

        socketRef?.current.on("server_response", (payload) => {
            // Handle incoming message
            console.log(payload, "payload");
            if (payload.data.ticket_id_ids) {
                localStorage.setItem("ticket_id", payload.data.ticket_id_ids);
            }
            if (payload.data.notification_type != "12") {
                //    setRecievedFromServer(payload);
            }
            if ((payload.data.user_id_ids == localStorage.getItem("user_id")) || (payload.data.user_id_ids == guestUserId)) {
                console.log("Received:", payload);
                let details = {
                    user_id_ids: localStorage.getItem("user_id"),
                };
                dispatch(
                    unreadNotificationCount(details, (res) => {
                        dispatch(setNotificationCount(res.data.data.count));
                    })
                );

                if (payload.data.notification_type != "12") {
                    dispatch(notificationReduxState(payload));
                }
                if (!callStatus) {
                    if (payload.data.notification_type == "2") {
                        localStorage.setItem("metaData", payload.data.meta_data);
                        const sentence = payload.data.body;
                        const words = sentence?.split(" ");
                        localStorage.setItem("callingName", words[0]);
                        dispatch(callTrue());
                    } else
                        if (payload.data.notification_type == "4") {
                            if (backDropLoaderStatus) {
                                dispatch(backLoaderFalse());
                                dispatch(updateBackDropLoaderWithoutStateFalse());
                                localStorage.setItem("roomCode", payload.data.room_id);
                                localStorage.setItem("ticket_id", payload.data.ticket_id_ids);
                                // navigate("/particularTicketDetails");
                                navigate("/videoCall");
                            }
                            if (backDropLoaderRejectedCase) {
                                dispatch(backDropLoaderRejectedCaseRedux());
                                dispatch(updateBackDropLoaderWithoutStateFalse());
                                localStorage.setItem("roomCode", payload.data.room_id);
                                localStorage.setItem("ticket_id", payload.data.ticket_id_ids);
                                // navigate("/particularTicketDetails");
                                navigate("/videoCall");
                            }
                        }
                        else if (payload.data.notification_type == "0") {
                            if (payload.data.trigger_call_flag == "1") {
                                const sentence = payload.data.body;
                                const words = sentence?.split(" ");
                                localStorage.setItem("callingName", words[0]);
                                localStorage.setItem("roomCode", payload.data.room_id);
                                localStorage.setItem("videoLink", payload.data.video_link);
                                dispatch(callTrue());
                            }
                        } else

                            if (payload.data.notification_type == "3") {
                                dispatch(backDropLoaderRejectedCaseRedux(true));
                                dispatch(backLoaderFalse());
                            } else if (payload.data.notification_type == "8") {
                                dispatch(backLoaderFalse());
                                //    setErrorMessage(payload.data.body)
                                //    setErrorModalStatus(true)
                            } else if (payload.data.notification_type == "13") {
                                // console.log(payload.data, "notificationDetails");
                                //    setGlobalNotificationData(payload.data);
                                //    setGlobalNotificationModalTrigger(true);
                            }
                }
                if (payload.data.notification_type == "12") {
                    //  setCheckActiveCall(new Date().getTime());
                    localStorage.setItem("updateCustomerDashboard", new Date().getTime());
                }
            } else {
                console.log("not mine");
            }

            // Update state to store the received messages
            // setMessages((prevMessages) => [...prevMessages, message]);
        });

        // Cleanup function to disconnect the socket on component unmount
        return () => {
            if (socketRef.current) {
                socketRef.current.disconnect();
            }
        };
    }, [guestUserId, backDropLoaderStatus, callStatus]);



    // New Scan Flow ends here ---------------------------------------------------------------------------

    const [toggleForAddImage, setToggleForAddImage] = useState(false);

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);


    const [discussionVal, setDiscussionVal] = useState("");
    const [noteObject, setNoteObject] = useState({});
    const [saveLoading, setSaveLoading] = useState(false);
    const [isNoteEdit, setIsNoteEdit] = useState(false);


    const [toggleForCameraActions, setToggleForCameraActions] = useState(false);

    const [imageForOCR, setImageForOCR] = useState(null);
    const [uploadImageForOcr, setUploadImageForOcr] = useState(null);
    const [ocrLoading, setOcrLoading] = useState(false);
    const [ocrText, setOcrText] = useState("");

    const [modalTriggerForAddPhoto, setModalTriggerForAddPhoto] = useState(false)
    const handleOpenModalAddPhoto = () => setModalTriggerForAddPhoto(true);
    const handleCloseModalAddPhoto = () => setModalTriggerForAddPhoto(false);




    // Reference to scroll to bottom
    const bottomRef = useRef(null);

    // Camera codes

    const videoRef = useRef(null);
    const streamRef = useRef(null); // Reference to store the media stream
    const [cameraInitializedLoading, setCameraInitializedLoading] = useState(false);
    const [isCameraAllowed, setIsCameraAllowed] = useState(true);
    const [screenShotLoading, setScreenShotLoading] = useState(false);

    // Attachment images for creating the DIY project
    const [uploadAttachedImage0, setUploadAttachedImage0] = useState(null);
    const [attachedImage0, setAttachedImage0] = useState(null);
    const [attachedImage0Id, setAttachedImage0Id] = useState('');

    const [uploadAttachedImage1, setUploadAttachedImage1] = useState(null);
    const [attachedImage1, setAttachedImage1] = useState(null);
    const [attachedImage1Id, setAttachedImage1Id] = useState('');

    const [uploadAttachedImage2, setUploadAttachedImage2] = useState(null);
    const [attachedImage2, setAttachedImage2] = useState(null);
    const [attachedImage2Id, setAttachedImage2Id] = useState('');

    const [uploadImageLimit, setUploadImageLimit] = useState(false);

    // Signup flow for the customer
    const [isPassword, setIsPassword] = useState(false);
    const [password, setPassword] = useState("Chilll@123");
    const [passwordConfirm, setPasswordConfirm] = useState("Chilll@123");
    const [passwordErrorMsg, setPasswordErrorMsg] = useState("");
    const [isPasswordConfirm, setIsPasswordConfirm] = useState(false);
    const [loaderActive, setLoaderActive] = useState(false);
    const [role, setRole] = useState(2);
    const [zipCode, setZipCode] = useState("");

    const uploadPicRef = useRef();
    const handleClickUploadPicture = () => {
        uploadPicRef.current.click();
    };

    useEffect(() => {
        const id = setTimeout(() => {
            setUploadImageLimit(false);
        }, 3000);
        return () => clearTimeout(id);
    }, [uploadImageLimit])

    // Attachment Upload 1
    const attachedImage1Ref = useRef();

    const handleClickAttachedImage0 = () => {
        attachedImage1Ref.current.click();
    }
    const handleAttachedImage0 = (e) => {
        if (e.target.files) {
            setUploadAttachedImage0(e.target.files[0]);
            setAttachedImage0(URL.createObjectURL(e.target.files[0]))
        }
    }

    const deleteAttachedImage0 = () => {
        setUploadAttachedImage0(null);
        setAttachedImage0(null)
    }

    const handleClickAttachedImage1 = () => {
        attachedImage1Ref.current.click();
    }
    const handleAttachedImage1 = (e) => {
        if (e.target.files) {
            setUploadAttachedImage1(e.target.files[0]);
            setAttachedImage1(URL.createObjectURL(e.target.files[0]))
        }
    }

    const deleteAttachedImage1 = () => {
        setUploadAttachedImage1(null);
        setAttachedImage1(null)
    }

    const deleteAttachedImage2 = () => {
        setUploadAttachedImage2(null);
        setAttachedImage2(null)
    }

    // Function to access the camera
    const getCameraStream = async () => {
        setCameraInitializedLoading(true);
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: 'environment' }, // Default to the back camera
                audio: false,
            });
            setIsCameraAllowed(true);
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
            }
            if (streamRef.current) {
                streamRef.current.getTracks().forEach((track) => track.stop());
            }
            streamRef.current = stream; // Store the stream in a reference
        } catch (error) {
            console.error('Error accessing the camera:', error);
            setIsCameraAllowed(false);
        } finally {
            setCameraInitializedLoading(false); // Set loading to false once the camera is initialized
        }
    };


    // Stop the camera stream
    const stopCameraStream = () => {
        if (streamRef.current) {
            const tracks = streamRef.current.getTracks();
            tracks.forEach((track) => track.stop());
            streamRef.current = null; // Clear the stream reference
            if (videoRef.current) {
                videoRef.current.srcObject = null;
            }
        }
    };



    // Sending the cropped images
    const [imgSrc, setImgSrc] = useState(null);
    const canvasRef = useRef(null);
    const [crop, setCrop] = useState({ x: 100, y: 100, width: 200, height: 200 });


    const canvasVideoRef = useRef(null);
    const [isPaused, setIsPaused] = useState(false);
    const [capturedImage, setCapturedImage] = useState(null);

    const capture = async () => {
        // const imageSrc = videoRef.current.getScreenshot();
        // if (videoRef.current) {
        //     // videoRef.current.pause(); // Pause the video stream
        //     // setIsPaused(true);

        //     const canvas = canvasVideoRef.current;
        //     const context = canvas.getContext('2d');
        //     canvas.width = videoRef.current.videoWidth;
        //     canvas.height = videoRef.current.videoHeight;
        //     context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

        //     // Convert to data URL and store the image
        //     const imageDataUrl = canvas.toDataURL('image/png');

        //     setImgSrc(imageDataUrl);
        // }

        if (videoRef.current) {
            setScreenShotLoading(true)
            try {
                // Capture screenshot of video element using html2canvas
                const canvas = await html2canvas(videoRef.current, {
                    useCORS: true, // Ensure cross-origin resources are captured
                    scale: 1, // Control scaling for better quality
                });

                // Convert the canvas to an image URL
                const imageDataUrl = canvas.toDataURL('image/png');

                // Store the captured image
                setImgSrc(imageDataUrl);
            } catch (error) {
                console.error('Error capturing screenshot:', error);
            } finally {
                setScreenShotLoading(false)
            }
        }
    };



    const handleContinue = (e) => {
        if (canvasRef.current) {
            //   setResponseBox(true)
            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');

            // Create a new canvas for the cropped area
            const croppedCanvas = document.createElement('canvas');
            croppedCanvas.width = crop.width;
            croppedCanvas.height = crop.height;
            const croppedCtx = croppedCanvas.getContext('2d');

            // Draw the cropped area from the original canvas onto the new canvas
            croppedCtx.drawImage(
                canvas,
                crop.x, crop.y, crop.width, crop.height,
                0, 0, crop.width, crop.height
            );
            setCapturedImage(croppedCanvas.toDataURL('image/jpeg'))

            if (attachedImage0 === null) {
                setAttachedImage0(croppedCanvas.toDataURL('image/jpeg'))
            } else if (attachedImage1 === null) {
                setAttachedImage1(croppedCanvas.toDataURL('image/jpeg'))
            } else if (attachedImage2 === null) {
                setAttachedImage2(croppedCanvas.toDataURL('image/jpeg'))
            }


            // Get the cropped image data as a base64 string
            const croppedImageData = croppedCanvas.toDataURL('image/jpeg').replace("data:", "").replace(/^.+,/, "");

            // Convert the base64 string to a Blob
            const byteCharacters = atob(croppedImageData);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'image/jpeg' });

            if (uploadAttachedImage0 === null) {
                setUploadAttachedImage0(blob)
            } else if (uploadAttachedImage1 === null) {
                setUploadAttachedImage1(blob)
            } else if (uploadAttachedImage2 === null) {
                setUploadAttachedImage2(blob)
            }

            // Pass the blob back to the parent component or use it as needed
            //   setResponseBox(true)
            //   setScanImageCheck(false);

            //   setLoading(true);
            //   setImage(blob);

            let formData = new FormData();

            formData.append("image", blob);

            setToggleForAddImage(false);
            setImgSrc(null);
            stopCameraStream();


            if (scanSteps == 1.2) {
                // For recognizing the category for creating service
                dispatch(
                    RecogObj(
                        formData,
                        (res) => {
                            setRecognizeImageLoading(false);

                            setScanSteps(2.1);

                            // setCanvasEnabled(false);
                            // setLoading(false);
                            setResValue(res?.data?.message);
                            // clearValue();
                            // setIsResValue(true);
                            setObjectCategoryName(res?.data?.data?.predicted_object_category);
                            setPredictionFlag(res?.data?.data?.prediction_flag);
                            setPredictedObjectClassId(
                                res?.data?.data?.predicted_object_class_id_ids
                            );
                            setPredictedObjectClassName(res?.data?.data?.predicted_object_name);
                            setProductTypeDetected(res?.data?.data?.predicted_object_name);
                            setPredictedLogId(res?.data?.data?.prediction_logs_id);
                            setProductTypeList(
                                normalizeProductTypeList(res?.data?.data?.product_type_list)
                            );

                            setDeviceColorChr(res?.data?.data?.device_color);
                            setDeviceBrandChr(res?.data?.data?.predicted_object_brand);

                            setModelNum(res?.data?.data?.predicted_object_model_number);
                            setSerialNumber(res?.data?.data?.predicted_object_serial_number);

                            setObjectCondition(res?.data?.data?.predicted_object_condition);

                            setPredictedObjectDetails(res?.data?.data);

                            // handleScanSteps(3);

                            if (res?.data?.data?.predicted_object_category) {
                                const catObj = catArr.find((cat) => cat.category_name_chr === res?.data?.data?.predicted_object_category);

                                if (catObj) {

                                    // console.log(catObj, 'filtered category object');

                                    setCatId(catObj.category_id_ids);
                                    setCategoryObj(catObj);
                                }
                            }
                            let prodObj = '';

                            if (res?.data?.data?.predicted_object_name) {
                                if (res?.data?.data?.product_type_list?.length > 0) {
                                    prodObj = res?.data?.data?.product_type_list.find((prod) => prod.product_type_name_chr === res?.data?.data?.predicted_object_name);

                                    if (prodObj) {

                                        // console.log(prodObj, 'filtered product type object');

                                        const normalizedProd = normalizeProductTypeItem(prodObj);
                                        setProdTypeId(normalizedProd.product_type_id_ids);
                                        setProductTypeObj(normalizedProd);
                                    }
                                }
                            }


                            if (res?.data?.data?.prediction_flag && prodObj) {
                                setScanSteps(2.2);
                            }
                        },
                        (res) => {
                            setRecognizeImageLoading(false);
                            setScanSteps(1.1);
                            getCameraStream();

                            setResponceMsg(res?.data?.message || `Something went wrong, please try after some time.`);
                            setToasterType("error");

                            setHandleToaster(true);
                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        }
                    )
                );
            }
        }
    };

    const [imgUploadLoading, setImgUploadLoading] = useState(false)

    const handleUploadPicture = async (e) => {
        if (e.target.files) {
            // setImage(e.target.files[0]);


            let formData = new FormData();

            const file = e.target.files[0];

            if (file && file.size > 1024 * 1024) { // Check if the file size is greater than 1 MB
                try {
                    setImgUploadLoading(true);
                    const options = {
                        maxSizeMB: 0.350, // Maximum size in MB
                        maxWidthOrHeight: 1920, // Maximum width or height
                        useWebWorker: true, // Use web worker for faster compression
                    };
                    const compressedFile = await imageCompression(file, options);
                    // console.log('Original file size:', (file.size / 1024 / 1024).toFixed(2), 'MB');
                    // console.log('Compressed file size:', (compressedFile.size / 1024 / 1024).toFixed(2), 'MB');

                    if (attachedImage0 === null) {
                        setUploadAttachedImage0(compressedFile);
                        setAttachedImage0(URL.createObjectURL(compressedFile))
                    } else if (attachedImage1 === null) {
                        setUploadAttachedImage1(compressedFile);
                        setAttachedImage1(URL.createObjectURL(compressedFile))
                    } else if (attachedImage2 === null) {
                        setUploadAttachedImage2(compressedFile);
                        setAttachedImage2(URL.createObjectURL(compressedFile))
                    }

                    formData.append("image", compressedFile, "scanned_image.png");

                    setToggleForAddImage(false);
                    setImgSrc(null);
                    stopCameraStream();

                    handleCloseModalAddPhoto();

                    // For recognizing the category for creating service
                    // dispatch(
                    //     RecogObj(
                    //         formData,
                    //         (res) => {
                    //             setObjectCategoryName(res.data.data.predicted_object_category);
                    //         },
                    //         () => {
                    //             // setLoading(false);
                    //         }
                    //     )
                    // );
                } catch (error) {
                    console.error('Error compressing the image:', error);
                    setImgUploadLoading(false);
                } finally {
                    setImgUploadLoading(false);
                }
            } else {
                // setUploadAttachedImage0(file);
                // setAttachedImage0(URL.createObjectURL(file));
                formData.append("image", file, "scanned_image.png");

                if (attachedImage0 === null) {
                    setUploadAttachedImage0(file);
                    setAttachedImage0(URL.createObjectURL(file))
                } else if (attachedImage1 === null) {
                    setUploadAttachedImage1(file);
                    setAttachedImage1(URL.createObjectURL(file))
                } else if (attachedImage2 === null) {
                    setUploadAttachedImage2(file);
                    setAttachedImage2(URL.createObjectURL(file))
                }

                setToggleForAddImage(false);
                setImgSrc(null);
                stopCameraStream();
                handleCloseModalAddPhoto();

                // For recognizing the category for creating service
                // dispatch(
                //     RecogObj(
                //         formData,
                //         (res) => {

                //             setObjectCategoryName(res.data.data.predicted_object_category);
                //         },
                //         () => {
                //             // setLoading(false);
                //         }
                //     )
                // );
            }
        }
    };

    const pauseAndCapture = () => {
        if (videoRef.current) {
            videoRef.current.pause(); // Pause the video stream
            setIsPaused(true);

            // Capture the current frame
            const canvas = canvasVideoRef.current;
            const context = canvas.getContext('2d');
            canvas.width = videoRef.current.videoWidth;
            canvas.height = videoRef.current.videoHeight;
            context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

            // Convert to data URL and store the image
            const imageDataUrl = canvas.toDataURL('image/png');
            setCapturedImage(imageDataUrl);
        }
    };

    const resumeVideo = () => {
        if (videoRef.current) {
            videoRef.current.play(); // Resume the video stream
            setIsPaused(false);
        }
    };


    const [openDoc, setOpenDoc] = React.useState(false);
    const [imageAttachURL, setImageAttachURL] = useState('');
    const [notesMessage, setNotesMessage] = useState("");

    const handleOpenDoc = () => {
        setOpenDoc(true);
    }
    const handleCloseDoc = () => {
        setOpenDoc(false);
        setNotesMessage('');
        setNoteObject({});
        setIsNoteEdit(false);
        setDiscussionVal('');
    }


    // Capture text functions comes here
    const handleCaptureOcrText = () => {
        if (canvasRef.current) {
            setOcrLoading(true)
            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');

            // Create a new canvas for the cropped area
            const croppedCanvas = document.createElement('canvas');
            croppedCanvas.width = crop.width;
            croppedCanvas.height = crop.height;
            const croppedCtx = croppedCanvas.getContext('2d');

            // Draw the cropped area from the original canvas onto the new canvas
            croppedCtx.drawImage(
                canvas,
                crop.x, crop.y, crop.width, crop.height,
                0, 0, crop.width, crop.height
            );
            setCapturedImage(croppedCanvas.toDataURL('image/jpeg'))

            setImageForOCR(croppedCanvas.toDataURL('image/jpeg'))


            // Get the cropped image data as a base64 string
            const croppedImageData = croppedCanvas.toDataURL('image/jpeg').replace("data:", "").replace(/^.+,/, "");

            // Convert the base64 string to a Blob
            const byteCharacters = atob(croppedImageData);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'image/jpeg' });

            setUploadImageForOcr(blob);

            // Pass the blob back to the parent component or use it as needed
            //   setResponseBox(true)
            //   setScanImageCheck(false);

            //   setLoading(true);
            //   setImage(blob);

            let formData = new FormData();

            formData.append("image", blob);

            // setToggleForAddImage(false);
            // setImgSrc(null);
            // stopCameraStream();

            // For recognizing the category for creating service
            dispatch(
                ocr(
                    formData,
                    (res) => {
                        setOcrLoading(false);
                        console.log(res.data?.note_chr, "OCR text")
                        setOcrText(res.data?.note_chr);

                        setToggleForAddImage(false);
                        setImgSrc(null);
                        stopCameraStream();

                        // handleOpenModalForSaveImageToNotes();
                    },
                    () => {
                        setOcrLoading(false);
                    }
                )
            );
        }
    };


    // Lock body scroll when scanStep === 1.1
    const scrollYRef = useRef(0);

    useEffect(() => {
        const shouldLock = scanSteps === 1.2 || toggleForAddImage;
        const body = document.body;

        if (scanSteps === 1.2 || toggleForAddImage) {
            // Save current scroll position
            scrollYRef.current = window.scrollY || window.pageYOffset;

            // Lock the body in place (no external CSS file needed)
            body.style.position = 'fixed';
            body.style.top = `-${scrollYRef.current}px`;
            body.style.left = '0';
            body.style.right = '0';
            body.style.width = '100%';
            body.style.overflow = 'hidden'; // extra safety

            // Optional: reduce pull-to-refresh chances on modern browsers
            body.style.overscrollBehaviorY = 'none';
        } else {
            // Restore body styles & scroll position
            body.style.position = '';
            body.style.top = '';
            body.style.left = '';
            body.style.right = '';
            body.style.width = '';
            body.style.overflow = '';
            body.style.overscrollBehaviorY = '';

            // Restore scroll
            window.scrollTo(0, scrollYRef.current);
        }

        // Cleanup if component unmounts while locked
        return () => {
            body.style.position = '';
            body.style.top = '';
            body.style.left = '';
            body.style.right = '';
            body.style.width = '';
            body.style.overflow = '';
            body.style.overscrollBehaviorY = '';
        };
    }, [scanSteps, toggleForAddImage]);


    // Guest home owner summiting form
    const handleSubmitGuestForm = async (e) => {
        e.preventDefault();
        // if (!validate()) return;

        // setSubmitting(true);
        // setSubmitError("");

        // try {
        //   const result = onSubmit?.({
        //     ...fields,
        //     phone: fields.phone.replace(/\D/g, ""),
        //   });
        //   if (result?.then) {
        //     await result;
        //   }
        //   setSubmitted(true);
        // } catch {
        //   setSubmitError("Something went wrong. Please try again.");
        // } finally {
        //   setSubmitting(false);
        // }

        if (!firstNameValidation(firstName)) {
            setIsFirstNameError(true)
            if (firstName === "") {
                setErrorFirstNameMsg(enterFirstName);
            } else {
                setErrorFirstNameMsg(validFirstName);
            }
        }

        if (!isPhone) {
            if (!emailValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
                if (emailPhoneValue === "") {
                    setIsEmailPhoneVal(true);
                    setLoginErrorMsg(errEmptyEmailOrPhone);
                } else if (!phoneValidation(emailPhoneValue)) {
                    setIsEmailPhoneVal(true);
                    setLoginErrorMsg(validEmail_OR_MobileNumberText);
                }
            }
        } else {
            if (!phoneValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
                if (emailPhoneValue === "") {
                    setIsEmailPhoneVal(true);
                    setLoginErrorMsg(errEmptyEmailOrPhone);
                } else if (!emailValidation(emailPhoneValue)) {
                    setIsEmailPhoneVal(true);
                    setLoginErrorMsg(validEmail_OR_MobileNumberText);
                }
            }
        }

        if (firstNameValidation(firstName) && (!isPhone ? emailValidation(emailPhoneValue) : phoneValidation(emailPhoneValue))) {
            if (isPhone) {
                let formData = new FormData();

                formData.append("first_name", firstName);
                formData.append("email_chr", '');
                formData.append("phone_code_id_int", parseInt(codeValue) || 1);
                formData.append("phone_number_int", parseInt(emailPhoneValue) || 0);
                formData.append("remark_message", messageText);
                formData.append("ticket_id", localStorage.getItem("ticket_id") || '');

                setSubmitting(true);
                setLoaderActive(true);

                dispatch(guestHomeownerForumApi(formData, (res) => {
                    setToasterType("success")
                    setResponceMsg(res.data.message);
                    // setHandleToaster(true);

                    // setScanSteps(5);
                    // setScanSteps(4.1);

                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);

                    setSubmitted(true);
                    setSubmitting(false);
                    handleSignUp(e);

                    // navigate("/activateUsers");

                    // setTimeout(() => {
                    //   setLoaderActive(false);
                    //   navigate("/activateUsers");
                    // }, 2000);

                }, (res) => {
                    setToasterType("error")
                    setResponceMsg(res.data.message);
                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                    setSubmitting(false)
                }))

            } else {
                let formData = new FormData();

                formData.append("first_name", firstName);
                formData.append("email_chr", emailPhoneValue);
                // formData.append("phone_code_id_int", parseInt(codeValue) || 1);
                // formData.append("phone_number_int", parseInt(emailPhoneValue) || 0);
                formData.append("remark_message", messageText);
                formData.append("ticket_id", localStorage.getItem("ticket_id") || '');

                setSubmitting(true);
                setLoaderActive(true);
                handleSignUp(e);

                dispatch(guestHomeownerForumApi(formData, (res) => {
                    setToasterType("success")
                    setResponceMsg(res.data.message);
                    // setHandleToaster(true);

                    // setScanSteps(5);
                    // setScanSteps(4.1);

                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);

                    setSubmitted(true);
                    setSubmitting(false);


                    // navigate("/activateUsers");

                    // setTimeout(() => {
                    //   setLoaderActive(false);
                    //   navigate("/activateUsers");
                    // }, 2000);

                }, (res) => {
                    setToasterType("error")
                    setResponceMsg(res.data.message);
                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                    setSubmitting(false)
                }))

            }
        }

    };

    const handleSignUp = (e) => {
        e.preventDefault();
        if (!firstNameValidation(firstName)) {
            setIsFirstNameError(true)
            if (firstName === "") {
                setErrorFirstNameMsg(enterFirstName);
            } else {
                setErrorFirstNameMsg(validFirstName);
            }
        }

        if (!isPhone) {
            if (!emailValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
                if (emailPhoneValue === "") {
                    setIsEmailPhoneVal(true);
                    setLoginErrorMsg(errEmptyEmailOrPhone);
                } else if (!phoneValidation(emailPhoneValue)) {
                    setIsEmailPhoneVal(true);
                    setLoginErrorMsg(validEmail_OR_MobileNumberText);
                }
            }
        } else {
            if (!phoneValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
                if (emailPhoneValue === "") {
                    setIsEmailPhoneVal(true);
                    setLoginErrorMsg(errEmptyEmailOrPhone);
                } else if (!emailValidation(emailPhoneValue)) {
                    setIsEmailPhoneVal(true);
                    setLoginErrorMsg(validEmail_OR_MobileNumberText);
                }
            }
        }

        if (!passwordValidation(password)) {
            setIsPassword(true);
            if (password === "") {
                setPasswordErrorMsg(validPassword)
            } else {
                setPasswordErrorMsg(passwordLengthText)
            }
        }

        if (!confirmPasswordValidation(password, passwordConfirm)) {
            setIsPasswordConfirm(true);
        }

        if (firstNameValidation(firstName) && (!isPhone ? emailValidation(emailPhoneValue) : phoneValidation(emailPhoneValue)) && passwordValidation(password) && confirmPasswordValidation(password, passwordConfirm)) {
            if (isPhone) {
                setLoaderActive(true)
                let details = {
                    first_name_chr: firstName,
                    last_name_chr: '',
                    alias_name_chr: '',
                    role_id_list: [parseInt(role)],
                    phone_code_id_int: parseInt(codeValue) || 1,
                    phone_number_int: parseInt(emailPhoneValue) || 0,
                    email_chr: '',
                    password: password,
                    confirm_password: passwordConfirm,
                    creator_user_id_ids: "",
                    creator_role_id_ids: "",
                    referal_code_chr: localStorage.getItem("referalCode") ? localStorage.getItem("referalCode") : "",
                    zip_code_int: parseInt(zipCode),
                    company_id_ids: localStorage.getItem("companyIdInvite") ? localStorage.getItem("companyIdInvite") : "",
                    // company_onboarding_flag: localStorage.getItem("companyIdInvite") ? 1 : 0,
                    company_onboarding_flag: 0,
                    invitation_id: localStorage.getItem("companyInvitationIdInvite") ? localStorage.getItem("companyInvitationIdInvite") : "",
                    service_request_id_ids: localStorage.getItem("ticket_id") || '',
                    is_guest_homeowner: 1,
                }

                dispatch(signUp(details, (res) => {
                    setToasterType("success");
                    setResponceMsg(res.data.message);
                    // setHandleToaster(true);


                    localStorage.setItem("countryCodeVal", codeValue);
                    localStorage.setItem("emailPhoneVal", emailPhoneValue);

                    // handleClearCompanyInvite();
                    //   setStepsForGuestHomeOwner(2);
                    // setScanSteps(5);
                    setScanSteps(4.1);

                    localStorage.getItem("referalCode") && localStorage.removeItem("referalCode");

                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);

                    // navigate("/activateUsers");
                    setLoaderActive(false);

                    // setTimeout(() => {
                    //   setLoaderActive(false);
                    //   navigate("/activateUsers");
                    // }, 2000);

                }, (res) => {
                    setToasterType("error")
                    setResponceMsg(res.data.message);
                    if (res.data.user_status == 1) {
                        setScanSteps(5);
                    } else {
                        setHandleToaster(true);
                    }
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                    setLoaderActive(false)
                }))

            } else {
                setLoaderActive(true)
                let details = {
                    first_name_chr: firstName,
                    last_name_chr: '',
                    alias_name_chr: '',
                    role_id_list: [parseInt(role)],
                    phone_code_id_int: parseInt(codeValue) || 1,
                    phone_number_int: parseInt(emailPhoneValue) || 0,
                    email_chr: emailPhoneValue,
                    password: password,
                    confirm_password: passwordConfirm,
                    creator_user_id_ids: "",
                    creator_role_id_ids: "",
                    referal_code_chr: localStorage.getItem("referalCode") ? localStorage.getItem("referalCode") : "",
                    zip_code_int: parseInt(zipCode),
                    company_id_ids: localStorage.getItem("companyIdInvite") ? localStorage.getItem("companyIdInvite") : "",
                    // company_onboarding_flag: localStorage.getItem("companyIdInvite") ? 1 : 0,
                    company_onboarding_flag: 0,
                    invitation_id: localStorage.getItem("companyInvitationIdInvite") ? localStorage.getItem("companyInvitationIdInvite") : "",
                    service_request_id_ids: localStorage.getItem("ticket_id") || '',
                    is_guest_homeowner: 1,
                }

                dispatch(signUp(details, (res) => {
                    setToasterType("success")
                    setResponceMsg(res.data.message);
                    // setHandleToaster(true);

                    localStorage.setItem("emailPhoneVal", emailPhoneValue);
                    // setStepsForGuestHomeOwner(2);
                    // setScanSteps(5);
                    setScanSteps(4.1);

                    // handleClearCompanyInvite();

                    localStorage.getItem("referalCode") && localStorage.removeItem("referalCode");

                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);

                    // navigate("/activateUsers");
                    setLoaderActive(false);

                    // setTimeout(() => {
                    //   setLoaderActive(false);
                    //   navigate("/activateUsers");
                    // }, 2000);

                }, (res) => {
                    setLoaderActive(false)

                    setToasterType("error")
                    setResponceMsg(res?.data?.message);
                    if (res.data.user_status == 1) {
                        setScanSteps(5);
                    } else {
                        setHandleToaster(true);
                    }
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }))
            }
        }
    }

    const handleActivateUser = (e) => {
        e.preventDefault();

        if (recievedCodeValue) {
            if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {

                setLoaderActive(true);

                let formData = new FormData();
                formData.append("phone_code_id_int", parseInt(localStorage.getItem("countryCodeVal")) || 1);
                formData.append("phone_number_int", parseInt(localStorage.getItem("emailPhoneVal")) || 0);
                formData.append("email_chr", "");
                formData.append("otp_chr", recievedCodeValue?.trim());
                localStorage.getItem("fcm_token") && formData.append("fcm_token_chr", localStorage.getItem("fcm_token"));
                formData.append("is_guest_homeowner", 1);

                dispatch(
                    activateUser(formData, (res) => {
                        // openNotification('success', 'topRight', res.data.message)
                        localStorage.setItem("receiverPlatform", parseInt(localStorage.getItem("emailPhoneVal")));
                        localStorage.setItem(
                            "receiverPlatformPhoneCode",
                            parseInt(localStorage.getItem("countryCodeVal"))
                        );

                        // dispatch(setIsSignUpFlagTrue());
                        setScanSteps(5);

                        setResponceMsg(res.data.message);
                        setLoaderActive(false);
                        setToasterType("success");
                        // setHandleToaster(true);

                        // if (res?.data?.login_flag) {
                        //   handleAuthentication(res.data)
                        // }
                    },
                        (error) => {
                            console.log(error.data.message)
                            // openNotification('failed', 'topRight', error.data.message)
                            setResponceMsg(error.data.message);
                            setToasterType("errror");
                            setHandleToaster(true);
                            setLoaderActive(false);

                            setIsCodeError(true)

                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        }
                    )
                );
            }

            else if (emailValidation(localStorage.getItem("emailPhoneVal"))) {
                setLoaderActive(true);


                let formData = new FormData();
                // parseInt(countryCode) && formData.append("phone_code_id_int",  0);
                // parseInt(phonenumber) && formData.append("phone_number_int", 0);
                formData.append("email_chr", localStorage.getItem("emailPhoneVal"));
                formData.append("otp_chr", recievedCodeValue?.trim());
                localStorage.getItem("fcm_token") && formData.append("fcm_token_chr", localStorage.getItem("fcm_token"));
                formData.append("is_guest_homeowner", 1);
                dispatch(
                    activateUser(
                        formData,
                        (res) => {
                            localStorage.setItem("receiverPlatform", localStorage.getItem("emailPhoneVal"));
                            setLoaderActive(false);

                            // dispatch(setIsSignUpFlagTrue());
                            setScanSteps(5);

                            setResponceMsg(res.data.message);
                            setToasterType("success");

                            // setHandleToaster(true);

                            // if (res?.data?.login_flag) {
                            //   handleAuthentication(res.data)
                            // }
                        },
                        (error) => {
                            console.log(error)

                            setIsCodeError(true)

                            setLoaderActive(false);
                            setToasterType("error");
                            setResponceMsg(error.data.message);
                            setHandleToaster(true);
                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        }
                    ))
            }
        } else {
            setIsCodeError(true)
        }

    }

    return (
        <>
            <div className='row mx-0'
                style={{
                    background: 'linear-gradient(182deg, rgb(250, 238, 227) 33%, rgb(255, 255, 255) 85%)'
                }}
            >

                {!toggleForAddImage ?
                    <>
                        {/* Top Steps heading and Top instructions */}
                        {<div
                            className="row mx-0"
                        >
                            {scanSteps != 5 &&
                                <div className='row mx-2 my-2 scan-top-toolbar'>
                                    <div
                                        className='col-12'
                                        style={{
                                            pointerEvents: scanSteps == 1.3 ? 'none' : 'auto',
                                            opacity: scanSteps == 1.3 ? '0.3' : '',
                                        }}
                                    >
                                        <span
                                            onClick={() => {
                                                handleBack();
                                            }}
                                            className="cursor-pointer px-3 py-2 text-black font-w600 overlay-action-btn rounded-3 scan-back-btn">
                                            <i className="bi bi-arrow-left me-2"></i> {`Back`}
                                        </span>
                                    </div>
                                </div>
                            }

                            {!showAgentLinkCaptureIntro &&
                                ((scanSteps == 1.1 || scanSteps == 1.2 || scanSteps == 1.3) || (scanSteps == 2.1 || scanSteps == 2.2) || (scanSteps == 3)) &&
                                (
                                    <div className="col-12 px-0 d-flex justify-content-center align-items-center" >

                                        <div
                                            className={`d-flex justify-content-center align-items-center fs-5 font-w600 text-black `}
                                        >
                                            <span>
                                                {`Step 
                                ${(scanSteps == 1.1 || scanSteps == 1.2 || scanSteps == 1.3) ? '1' :
                                                        (scanSteps == 2.1 || scanSteps == 2.2) ? '2' : '3'}
                                         of 3`}
                                            </span>
                                        </div>

                                    </div>
                                )}

                            {!showAgentLinkCaptureIntro && (
                                <div className="col-12 px-0 d-flex justify-content-center fs-5 align-items-center scan-step-subtext" >
                                    <div
                                        className={`d-flex justify-content-center align-items-center fs-6 font-w500 text-black w-100`}
                                    >
                                        {
                                            scanSteps == 1.1 ?
                                                <span className='text-center'>
                                                    {/* {`Take a pic of what you could use some help with`} */}
                                                </span>
                                                :
                                                scanSteps == 1.2 ?
                                                    <span className='text-center'>
                                                        {`Does this Pic Capture your project well?`}
                                                    </span>
                                                    :
                                                    scanSteps == 1.3 ?
                                                        <span className='text-center'>
                                                            {`We're analyzing your image`}
                                                        </span> :
                                                        scanSteps == 2.1 ?
                                                            <>
                                                                {/* {predictionFlag ?
                                                                <></> : */}
                                                                <>
                                                                    <div
                                                                        className='align-items-center d-flex font-w500 fs-6 justify-content-center mx-3 px-3 py-1 rounded-2 text-black w-100 flex-column w-100'
                                                                        style={{
                                                                            background: 'rgba(236, 228, 222, 1)'
                                                                        }}
                                                                    >
                                                                        <span className='text-center text-danger fs-6 font-w600 pb-1'>
                                                                            {`Device not Detected`}
                                                                        </span>
                                                                        <span className='text-center fs-7'>
                                                                            {`We apologize we unable to identify your device.`}
                                                                        </span>
                                                                        <span className='text-center fs-7'>
                                                                            {`Please select from the options below`}
                                                                        </span>
                                                                    </div>
                                                                </>
                                                                {/* } */}
                                                            </>
                                                            :
                                                            scanSteps == 2.2 ?
                                                                <>
                                                                    <div
                                                                        className='d-flex justify-content-center align-items-center flex-column px-3 py-2 rounded-3'
                                                                        style={{
                                                                            background: 'rgba(255, 231, 213, 1)',
                                                                            color: 'rgba(216, 122, 36, 1)'
                                                                        }}
                                                                    >
                                                                        <span className='text-center font-w600'>
                                                                            {`Verify the info looks right or fix it manually`}
                                                                        </span>

                                                                    </div>
                                                                </>
                                                                :
                                                                scanSteps == 3 ?
                                                                    <>
                                                                        <div className='d-flex justify-content-center align-items-center flex-column'>
                                                                            <span className='text-center text-black font-w600'>
                                                                                {`Add additional Images or Notes`}
                                                                            </span>
                                                                            <span className='text-center'>
                                                                                {`(Optional)`}
                                                                            </span>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    <></>
                                        }
                                    </div>
                                </div>
                            )}
                        </div>}

                        <div
                            className={`row mx-0 d-flex flex-column${showAgentLinkCaptureIntro ? ' scan-agent-link-capture' : ''}`}
                            style={{ minHeight: toggleForSelectProductType ? '120dvh' : 'auto' }}
                        >
                            {/* Steps starts from here */}
                            {/* Taking pic of broken device */}
                            {(scanSteps == 0.1) ?
                                <>
                                    <div className='row mx-0 '>
                                        {window.innerWidth > 768 && <div className='col-md-3'></div>}
                                        <div
                                            className={`col-md-6 d-flex position-relative px-3 py-1`}
                                        >
                                            <div className='row mx-0'>
                                                <div className='row mx-0 mb-3'>
                                                    <div className="col-12 px-0 d-flex align-items-center mb-5">
                                                        <img
                                                            src={logo}
                                                            alt="Chilll"
                                                            className="scan-agent-link-intro__logo"
                                                        />
                                                    </div>

                                                    <div className="col-12 px-0 d-flex justify-content-center align-items-center mb-5 flex-column">
                                                        <span className='text-center text-black font-w600 fs-3'>
                                                            {`Let’s see what’s`}
                                                        </span>
                                                        <span className='text-center text-black font-w600 fs-3'>
                                                            {`going on.`}
                                                        </span>
                                                    </div>

                                                    <div
                                                        className="col-12 p-2 d-flex justify-content-center align-items-center rounded-2 font-w600"
                                                        style={{
                                                            background: 'rgb(234, 245, 221)',
                                                            color: 'rgb(78, 148, 38)',
                                                        }}
                                                    >
                                                        <span className='me-2' style={{}}><i className="bi bi-check-lg"></i></span>
                                                        <span className='me-2' style={{}}>{`Free`}</span>
                                                        <span className='rounded-circle  me-2' style={{ width: '4px', height: '4px', background: 'rgb(78, 148, 38)' }}></span>
                                                        <span className='me-2' style={{}}>{`No account`}</span>
                                                        <span className='rounded-circle me-2' style={{ width: '4px', height: '4px', background: 'rgb(78, 148, 38)' }}></span>
                                                        <span style={{}} >{`No app to downloa`}</span>
                                                    </div>

                                                    <div className='col-12 py-2 pt-4'>

                                                        <div className='d-flex  mx-0 mb-3' style={{ height: '', background: '' }}>
                                                            <div className='d-flex justify-content-center align-items-center' style={{ width: '60px', background: '' }}>
                                                                <div className='rounded-2 h-100 w-100 d-flex justify-content-center align-items-center' style={{ background: 'rgb(253, 241, 225)', color: 'rgb(238, 123, 61)' }}>
                                                                    <MdOutlineCameraAlt style={{ fontSize: '25px' }} />
                                                                </div>
                                                            </div>

                                                            <div className=' ps-3' style={{ background: '' }}>
                                                                <div className="d-flex flex-column" >
                                                                    <span className='text-black font-w600 fs-4'>
                                                                        {`Show us`}
                                                                    </span>
                                                                    <span className=''>
                                                                        {`One quick photo of the project`}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='d-flex  mx-0 mb-3' style={{ height: '', background: '' }}>
                                                            <div className='d-flex justify-content-center align-items-center' style={{ width: '60px', background: '' }}>
                                                                <div className='rounded-2 h-100 w-100 d-flex justify-content-center align-items-center' style={{ background: 'rgb(253, 241, 225)', color: 'rgb(238, 123, 61)' }}>
                                                                    <TbMessage2 style={{ fontSize: '25px' }} />
                                                                </div>
                                                            </div>

                                                            <div className=' ps-3' style={{ background: '' }}>
                                                                <div className="d-flex flex-column" >
                                                                    <span className='text-black font-w600 fs-4'>
                                                                        {`Tell us (a little)`}
                                                                    </span>
                                                                    <span className=''>
                                                                        {`Add anything we should know`}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='d-flex  mx-0 mb-3' style={{ height: '', background: '' }}>
                                                            <div className='d-flex justify-content-center align-items-center' style={{ width: '60px', background: '' }}>
                                                                <div className='rounded-2 h-100 w-100 d-flex justify-content-center align-items-center' style={{ background: 'rgb(253, 241, 225)', color: 'rgb(238, 123, 61)' }}>
                                                                    <LuSend style={{ fontSize: '25px' }} />
                                                                </div>
                                                            </div>

                                                            <div className=' ps-3' style={{ background: '' }}>
                                                                <div className="d-flex flex-column" >
                                                                    <span className='text-black font-w600 fs-4'>
                                                                        {`Video Chat with a Pro`}
                                                                    </span>
                                                                    <span className=''>
                                                                        {`An honest, unbiased fix plan`}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div className='col-12 px-0 d-flex justify-content-center align-items-center mb-3 mt-5'>
                                                    <span className='fs-4'>
                                                        {`Start with an Estimate - Finish with a Fix`}
                                                    </span>
                                                </div>



                                                <div className='col-12 px-0 d-flex justify-content-center align-items-center mb-2'>
                                                    <PrimaryButton
                                                        buttonName={"Start my free estimate "}
                                                        onClick={(e) => {
                                                            setScanSteps(1.1);
                                                            getCameraStream();
                                                        }}
                                                        needIcon={true}
                                                        isLoading={false}
                                                        loadingMessage={"Saving..."}
                                                        className={""}
                                                        style={{
                                                            width: '100%',
                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                            fontWeight: '600',
                                                        }}
                                                    />
                                                </div>

                                            </div>
                                        </div>
                                        {window.innerWidth > 768 && <div className='col-md-3'></div>}
                                    </div>
                                </> :
                                (scanSteps === 1.1 || scanSteps === 1.2) ?
                                    <div className={`scan-capture-stage${showAgentLinkCaptureIntro ? ' scan-capture-stage--agent-link' : ''}`}>
                                        {showAgentLinkCaptureIntro && (
                                            <div className="col-12 scan-agent-link-intro">
                                                <img
                                                    src={logo}
                                                    alt="Chilll"
                                                    className="scan-agent-link-intro__logo"
                                                />
                                                {!imgSrc ? (
                                                    <h1 className="scan-agent-link-intro__headline">
                                                        Show us what&apos;s going on — our expert will diagnose it from here.
                                                    </h1>
                                                ) : (
                                                    <p className="scan-agent-link-intro__sub">
                                                        Does this photo capture your project well?
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                        <div className='row mx-0 scan-camera-row'>
                                            {window.innerWidth > 768 && <div className='col-md-1'></div>}
                                            <div
                                                className={`col-12 col-md-10 d-flex justify-content-center align-items-center overflow-hidden scan-camera-viewport${imgSrc ? ' scan-camera-viewport--crop' : ''} ${!imgSrc && 'bg-light'} position-relative`}
                                            >
                                                {!imgSrc && <>
                                                    {!isCameraAllowed &&
                                                        <div
                                                            className='d-flex flex-column position-absolute  justify-content-center align-items-center w-100'
                                                            style={{
                                                                top: "50%",
                                                                left: "50%",
                                                                transform: "translate(-50%, -50%)",
                                                                zIndex: "1",
                                                            }}
                                                        >
                                                            <span
                                                                className="fs-4 text-center text-black font-w600"
                                                            >
                                                                {"Camera access is blocked."}
                                                            </span>

                                                            <span
                                                                className=" fs-6 text-center font-w600"
                                                            >
                                                                {"Please enable camera access in your browser settings and refresh the page."}
                                                            </span>
                                                        </div>
                                                    }

                                                    {isCameraAllowed && false &&
                                                        <div
                                                            className='d-flex flex-column position-absolute  justify-content-center align-items-center w-100 h-100'
                                                            style={{
                                                                top: "0%",
                                                                left: "0%",
                                                                // transform: "translate(-50%, -50%)",
                                                                zIndex: "1",
                                                                backgroundColor: '#0000007a',
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    width: '70%',
                                                                    height: '65%',
                                                                    background: `yellow`,
                                                                    borderRadius: '10px',
                                                                    border: '2px solid white',
                                                                }}
                                                            >

                                                            </div>

                                                        </div>
                                                    }

                                                    {isCameraAllowed &&
                                                        <div
                                                            className='d-flex flex-column position-absolute justify-content-center align-items-center w-100 h-100'
                                                            style={{
                                                                top: "0%",
                                                                left: "0%",
                                                                zIndex: "1",

                                                            }}
                                                        >

                                                            <div
                                                                className='w-100'
                                                                style={{
                                                                    height: '5%',
                                                                    backgroundColor: '#0000007a',
                                                                }}
                                                            > </div>

                                                            <div
                                                                className='row w-100'
                                                                style={{
                                                                    height: '90%',
                                                                    backgroundColor: '',
                                                                }}
                                                            >
                                                                <div className='col-1 h-100' style={{ backgroundColor: '#0000007a', }}></div>
                                                                <div className='col-10 h-100'>
                                                                    <div
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            backgroundColor: 'transparent', // Make the background transparent
                                                                            borderRadius: '15px', // Rounded corners
                                                                            position: 'relative', // Position for pseudo-elements
                                                                        }}
                                                                    >
                                                                        {/* Pseudo-elements to add borders only at corners */}
                                                                        <div
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: '0', left: '0',
                                                                                width: '50px', height: '50px',
                                                                                borderTop: '3px solid white',
                                                                                borderLeft: '3px solid white',
                                                                                borderTopLeftRadius: '8px', // Round the top-left corner
                                                                            }}
                                                                        ></div>
                                                                        <div
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: '0', right: '0',
                                                                                width: '50px', height: '50px',
                                                                                borderTop: '3px solid white',
                                                                                borderRight: '3px solid white',
                                                                                borderTopRightRadius: '8px', // Round the top-right corner
                                                                            }}
                                                                        ></div>
                                                                        <div
                                                                            style={{
                                                                                position: 'absolute',
                                                                                bottom: '0', left: '0',
                                                                                width: '50px', height: '50px',
                                                                                borderBottom: '3px solid white',
                                                                                borderLeft: '3px solid white',
                                                                                borderBottomLeftRadius: '8px', // Round the bottom-left corner
                                                                            }}
                                                                        ></div>
                                                                        <div
                                                                            style={{
                                                                                position: 'absolute',
                                                                                bottom: '0', right: '0',
                                                                                width: '50px', height: '50px',
                                                                                borderBottom: '3px solid white',
                                                                                borderRight: '3px solid white',
                                                                                borderBottomRightRadius: '8px', // Round the bottom-right corner
                                                                            }}
                                                                        ></div>
                                                                    </div>
                                                                </div>
                                                                <div className='col-1 h-100' style={{ backgroundColor: '#0000007a', }}></div>

                                                            </div>

                                                            {!fromAgentLink && (
                                                                <div
                                                                    className='d-flex justify-content-center align-items-center w-100 p-2'
                                                                    style={{
                                                                        height: '15%',
                                                                        backgroundColor: '#00000075',
                                                                    }}
                                                                >
                                                                    <div
                                                                        className='d-flex justify-content-center align-items-center flex-column p-1 px-3 rounded-3'
                                                                        style={{
                                                                            backgroundColor: '#00000075'
                                                                        }}
                                                                    >
                                                                        <span className='fs-6 fw-bold text-white text-center'>{`Take A Photo`}</span>
                                                                        <span className='fs-7 text-white text-center'>{`Take a pic of what you could use some help with`}</span>
                                                                    </div>
                                                                </div>
                                                            )}






                                                        </div>


                                                    }



                                                    <video
                                                        ref={videoRef}
                                                        autoPlay
                                                        playsInline
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover',
                                                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                                                        }}
                                                    ></video>
                                                    {/* <canvas
                                                    ref={canvasVideoRef}
                                                    style={{ display: 'none' }} // Hide canvas element
                                                ></canvas> */}
                                                </>
                                                }


                                                {imgSrc && (
                                                    <ImageCropper imgSrc={imgSrc} canvasRef={canvasRef} setCrop={setCrop} />
                                                )}
                                            </div>
                                            {window.innerWidth > 768 && <div className='col-md-1'></div>}
                                        </div>
                                        <div className='row mx-0 scan-capture-actions'>
                                            <div className='col-12 px-0 d-flex justify-content-center align-items-center my-2'>
                                                <>
                                                    {imgSrc ?
                                                        <>
                                                            <PrimaryButton
                                                                buttonName={"RETAKE"}
                                                                onClick={() => { setImgSrc(null); getCameraStream(); }}
                                                                isLoading={false}
                                                                loadingMessage={"Saving..."}
                                                                className={"me-3"}
                                                                style={{
                                                                    width: window.innerWidth > 768 ? '150px' : '125px',
                                                                    fontSize: window.innerWidth > 768 ? '14px' : '10px',
                                                                    background: 'white',
                                                                    border: '2px solid rgba(79, 93, 116, 1)',
                                                                    // boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                    fontWeight: '600',
                                                                    color: 'black'
                                                                }}
                                                            />

                                                            <PrimaryButton
                                                                buttonName={"YES-ANALYZE"}
                                                                onClick={(e) => {
                                                                    handleContinue(e);
                                                                    setScanSteps(1.3);
                                                                }}
                                                                isLoading={false}
                                                                loadingMessage={"Saving..."}
                                                                className={"scan-capture-actions__analyze"}
                                                                style={{
                                                                    width: window.innerWidth > 768 ? '240px' : '190px',
                                                                    fontSize: window.innerWidth > 768 ? '14px' : '10px',
                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                    fontWeight: '600',
                                                                }}
                                                            />



                                                        </> :
                                                        <>
                                                            {/* <div className='row mx-0'>
                                                    <div
                                                        className='col-12 '
                                                        style={{
                                                            pointerEvents: screenShotLoading ? "none" : "auto",
                                                            opacity: screenShotLoading ? "0.5" : "1",
                                                        }}
                                                    >
                                                    </div>
                                                </div> */}
                                                            <PrimaryButton
                                                                buttonName={"CAPTURE"}
                                                                onClick={() => {
                                                                    capture();
                                                                    setScanSteps(1.2);
                                                                }}
                                                                isLoading={screenShotLoading}
                                                                loadingMessage={"LOADING..."}
                                                                className={""}
                                                                style={{
                                                                    width: '200px',
                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                    fontWeight: '600',
                                                                }}
                                                            />
                                                        </>
                                                    }
                                                </>
                                            </div>
                                        </div>
                                    </div> :
                                    // Scanning Screen while recognize image
                                    (scanSteps == 1.3) ?
                                        <>
                                            <div className='row mx-0 '>
                                                {window.innerWidth > 768 && <div className='col-md-1'></div>}
                                                <div
                                                    className={`col-md-10 d-flex justify-content-center align-items-center overflow-hidden bg-light position-relative scan-wrap`}
                                                    style={{ height: '65dvh' }}
                                                >
                                                    <img src={attachedImage0} className='' alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />

                                                    {/* scanning line overlay */}
                                                    <span className="scan-line" aria-hidden="true" />
                                                    {/* (optional) soft beam glow under the line */}
                                                    <span className="scan-beam" aria-hidden="true" />
                                                </div>
                                                {window.innerWidth > 768 && <div className='col-md-1'></div>}
                                            </div>
                                            <div className='row mx-0'>
                                                <div className='col-12 px-0 d-flex justify-content-center align-items-center my-2'>
                                                    <>
                                                        <span className='fs-4 text-black font-w600'>{`SCANNING IMAGE...`}</span>
                                                    </>
                                                </div>
                                            </div>
                                        </> :
                                        // Category Selection Screen
                                        (scanSteps == 2.1) ?
                                            <>
                                                <div className='row mx-0 '>
                                                    {window.innerWidth > 768 && <div className='col-md-3'></div>}
                                                    <div
                                                        className={`col-md-6 d-flex position-relative px-3 py-1 flex-column`}
                                                    >
                                                        {/* New Figma design */}
                                                        <div className='row mx-0'>

                                                            {toggleForCatSelect == 1 ?
                                                                <>
                                                                    <div className='col-12 px-0'>
                                                                        <span className='text-black font-w600'>{`Device Category`}</span>
                                                                    </div>

                                                                    <div className='col-12 px-0 mt-2'>
                                                                        <div className='d-flex align-items-center overflow-auto pb-2 flex-column'>
                                                                            {catArr.length > 0 ?
                                                                                <>
                                                                                    {catArr.map((ele, ind) => {
                                                                                        return (
                                                                                            ele?.category_name_chr !== "Inspection" && (
                                                                                                <div
                                                                                                    key={ind}
                                                                                                    onClick={() => {
                                                                                                        handleSetCatId(ele);
                                                                                                        setParticularID(ind);
                                                                                                        // setIsCustomResMsg(true);
                                                                                                    }}
                                                                                                    className={`cursor-pointer p-2 rounded-2 shadow-sm d-flex align-items-center w-100 mb-2`}
                                                                                                    style={{
                                                                                                        // width: '65px',
                                                                                                        // minWidth: '65px',
                                                                                                        height: '60px',
                                                                                                        border: catId === ele?.category_id_ids ? '2px solid #FF7401' : '1px solid #ccc',
                                                                                                        background: catId === ele?.category_id_ids ? 'rgba(255, 238, 208, 1)' : 'white'
                                                                                                    }}
                                                                                                >
                                                                                                    <img
                                                                                                        className='me-3'
                                                                                                        src={ele?.category_image_url_chr}
                                                                                                        alt={ele?.category_display_name_chr}
                                                                                                        style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                                                                                                    />

                                                                                                    <span className='fs-5 text-black font-w600 mt-2 text-center'>{ele.category_display_name_chr}</span>

                                                                                                </div>
                                                                                            )
                                                                                        )
                                                                                    })

                                                                                    }
                                                                                </> :
                                                                                <>
                                                                                    <div className='d-flex justify-content-center align-items-center'>
                                                                                        <span className='text-black font-w500'>{`No Category Found`}</span>
                                                                                    </div>
                                                                                </>
                                                                            }
                                                                        </div>
                                                                    </div>

                                                                    {categoryErr &&
                                                                        <div className='col-12 px-0'>
                                                                            <span className='text-danger font-w500'>{`Please select a device category`}</span>
                                                                        </div>
                                                                    }

                                                                    <div className='col-12 px-0 d-flex justify-content-center align-items-center my-2'>
                                                                        <PrimaryButton
                                                                            buttonName={"NEXT"}
                                                                            onClick={() => {
                                                                                const selectedCategory = categoryObj;
                                                                                if (Object.keys(selectedCategory).length === 0) {
                                                                                    setCategoryErr(true);
                                                                                    return;
                                                                                }
                                                                                setToggleForCatSelect(2);
                                                                            }}
                                                                            isLoading={screenShotLoading}
                                                                            loadingMessage={"LOADING..."}
                                                                            className={""}
                                                                            style={{
                                                                                width: '100%',
                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                fontWeight: '600',
                                                                            }}
                                                                        />
                                                                    </div>

                                                                </> :
                                                                <>
                                                                    {productTypeList.length > 0 &&
                                                                        <>
                                                                            <div className='col-12 px-0'>
                                                                                <span className='text-black font-w600'>{`Select the ${objectCategoryName} Device Type`}</span>
                                                                            </div>

                                                                            <div
                                                                                className='col-12 px-0 mt-2 overflow-auto'
                                                                                style={{
                                                                                    maxHeight: 'calc(100dvh - 423px)',
                                                                                }}
                                                                            >
                                                                                <div className='d-flex align-items-center overflow-auto pb-2 flex-column'>
                                                                                    {productTypeResp ?
                                                                                        <>
                                                                                            {[...Array(4)].map((ele, ind) => {
                                                                                                return (
                                                                                                    <div
                                                                                                        key={ind}
                                                                                                        className={`rounded-2 shadow-sm d-flex w-100 align-items-center mb-2 flex-column`}
                                                                                                        style={{
                                                                                                            width: '85px',
                                                                                                            minWidth: '85px',
                                                                                                            height: '60px',
                                                                                                            border: '1px solid #ccc',
                                                                                                        }}
                                                                                                    >
                                                                                                        <SkeletonDivElement
                                                                                                            height={"100%"}
                                                                                                            borderRadius={'10px'}
                                                                                                            // rows={6}
                                                                                                            marginBottom='0px'
                                                                                                        />
                                                                                                    </div>

                                                                                                )
                                                                                            })}
                                                                                        </> :
                                                                                        <>
                                                                                            {productTypeList.length > 0 ?
                                                                                                <>
                                                                                                    {productTypeList.map((ele, ind) => {
                                                                                                        return (

                                                                                                            <div
                                                                                                                key={ind}
                                                                                                                onClick={(e) => {
                                                                                                                    e.stopPropagation();
                                                                                                                    handleSetProductType(ele);
                                                                                                                    setProductTypeDetected(getProductTypeDisplayName(ele));
                                                                                                                }}
                                                                                                                className={`cursor-pointer p-2 rounded-2 shadow-sm d-flex align-items-center mb-2 w-100`}
                                                                                                                style={{
                                                                                                                    // width: '85px',
                                                                                                                    // minWidth: '85px',
                                                                                                                    height: '60px',
                                                                                                                    border: prodTypeId === ele?.product_type_id_ids ? '2px solid #FF7401' : '1px solid #ccc',
                                                                                                                    background: prodTypeId === ele?.product_type_id_ids ? 'rgba(255, 238, 208, 1)' : 'white'
                                                                                                                }}
                                                                                                            >
                                                                                                                <img
                                                                                                                    className='me-3'
                                                                                                                    src={ele?.product_type_image_url_chr ? ele?.product_type_image_url_chr : unavailbleServiceImg}
                                                                                                                    alt={getProductTypeDisplayName(ele)}
                                                                                                                    style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                                                                                                                />

                                                                                                                <span className='fs-5 text-black font-w600 mt-2 text-center'>{getProductTypeDisplayName(ele)}</span>

                                                                                                            </div>

                                                                                                        )
                                                                                                    })}
                                                                                                </> :
                                                                                                <>
                                                                                                    <div className='d-flex justify-content-center align-items-center '>
                                                                                                        <span className=' text-black font-w500 '>{`No Device Found`}</span>
                                                                                                    </div>
                                                                                                </>
                                                                                            }
                                                                                        </>
                                                                                    }
                                                                                </div>
                                                                            </div>

                                                                            {productTypeErr &&
                                                                                <div className='col-12 px-0'>
                                                                                    <span className='text-danger font-w500'>{`Please select a device type`}</span>
                                                                                </div>
                                                                            }
                                                                        </>
                                                                    }

                                                                    <div className='col-12 px-0'>
                                                                        <div className="separator-custom my-3">
                                                                            <div className="line-custom me-3 bg-black"></div>
                                                                            <span className="text-custom fs-6 text-black font-w600">{`Optional`}</span>
                                                                            <div className="line-custom ms-3 bg-black"></div>
                                                                        </div>
                                                                    </div>

                                                                    <div className='col-12 px-0 d-flex mb-3'>
                                                                        <div className='d-flex align-items-center me-3'>
                                                                            <span className={`fs-6 text-primary font-w600 ${isEditingBrand ? 'mb-3' : ''}`}>{`Brand`}</span>
                                                                        </div>
                                                                        <div
                                                                            className='d-flex align-items-center justify-content-between  w-100'
                                                                            style={{
                                                                                borderBottom: !isEditingBrand ? '1px dashed orange' : '',
                                                                            }}
                                                                        >
                                                                            {isEditingBrand ?
                                                                                <InputField
                                                                                    labelName={"Brand"}
                                                                                    value={deviceBrandChr}
                                                                                    onChange={handleDeviceBrandChr}
                                                                                    onBlur={() => { }}
                                                                                /> :

                                                                                <span className='fs-5'>{`${deviceBrandChr}`}</span>
                                                                            }

                                                                            <div className={`d-flex align-items-center justify-content-center mx-2 ${isEditingBrand ? 'mb-3' : ''}`}>
                                                                                {isEditingBrand ?
                                                                                    <div className="tooltipCustom">
                                                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Save"}</span>
                                                                                        <span
                                                                                            className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                            onClick={(e) => { setIsEditingBrand(false) }}
                                                                                            style={{ height: '30px', width: '30px', }}
                                                                                        >
                                                                                            <i className="bi bi-check2-circle text-success" style={{ color: 'green', fontSize: '18px' }} />
                                                                                        </span>
                                                                                    </div>
                                                                                    :
                                                                                    <div className="tooltipCustom">
                                                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                                                                        <span
                                                                                            className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center bg-light"
                                                                                            onClick={(e) => {
                                                                                                setIsEditingBrand(true);
                                                                                            }}
                                                                                            style={{ height: '30px', width: '30px', }}
                                                                                        >
                                                                                            <i className="bi bi-pencil" style={{ fontSize: '14px' }} />
                                                                                        </span>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className='col-12 px-0 d-flex mb-3'>
                                                                        <div className='d-flex align-items-center me-3'>
                                                                            <span className={`fs-6 text-primary font-w600 ${isEditingModel ? 'mb-3' : ''}`}>{`Model`}</span>
                                                                        </div>
                                                                        <div
                                                                            className='d-flex align-items-center justify-content-between  w-100'
                                                                            style={{
                                                                                borderBottom: !isEditingModel ? '1px dashed orange' : '',
                                                                            }}
                                                                        >
                                                                            {isEditingModel ?
                                                                                <InputField
                                                                                    labelName={"Model"}
                                                                                    value={modelNum}
                                                                                    onChange={handleModelNum}
                                                                                    onBlur={() => { }}
                                                                                /> :

                                                                                <span className='fs-5'>{`${modelNum}`}</span>
                                                                            }

                                                                            <div className={`d-flex align-items-center justify-content-center mx-2 ${isEditingModel ? 'mb-3' : ''}`}>
                                                                                {isEditingModel ?
                                                                                    <div className="tooltipCustom">
                                                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Save"}</span>
                                                                                        <span
                                                                                            className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                            onClick={(e) => { setIsEditingModel(false) }}
                                                                                            style={{ height: '30px', width: '30px', }}
                                                                                        >
                                                                                            <i className="bi bi-check2-circle text-success" style={{ color: 'green', fontSize: '18px' }} />
                                                                                        </span>
                                                                                    </div>
                                                                                    :
                                                                                    <div className="tooltipCustom">
                                                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                                                                        <span
                                                                                            className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center bg-light"
                                                                                            onClick={(e) => {
                                                                                                setIsEditingModel(true);
                                                                                            }}
                                                                                            style={{ height: '30px', width: '30px', }}
                                                                                        >
                                                                                            <i className="bi bi-pencil" style={{ fontSize: '14px' }} />
                                                                                        </span>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className='col-12 px-0 d-flex justify-content-center align-items-center mb-2'>
                                                                        <PrimaryButton
                                                                            buttonName={"CONFIRM"}
                                                                            onClick={() => {
                                                                                handleSelectCategoryAndProctucType();
                                                                            }}
                                                                            isLoading={screenShotLoading}
                                                                            loadingMessage={"LOADING..."}
                                                                            className={""}
                                                                            style={{
                                                                                width: '100%',
                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                fontWeight: '600',
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </>
                                                            }







                                                        </div>

                                                        {/* Old design keeping it for the current changes */}
                                                        {false &&
                                                            <div className='row mx-0'>
                                                                <div className='col-12 px-0'>
                                                                    <span className='text-black font-w600'>{`Device Category`}</span>
                                                                </div>

                                                                <div className='col-12 px-0 mt-2'>
                                                                    <div className='d-flex align-items-center overflow-auto pb-2'>
                                                                        {catArr.length > 0 ?
                                                                            <>
                                                                                {catArr.map((ele, ind) => {
                                                                                    return (
                                                                                        ele?.category_name_chr !== "Inspection" && (
                                                                                            <div
                                                                                                key={ind}
                                                                                                onClick={() => {
                                                                                                    handleSetCatId(ele);
                                                                                                    setParticularID(ind);
                                                                                                    // setIsCustomResMsg(true);
                                                                                                }}
                                                                                                className={`cursor-pointer p-2 rounded-2 shadow-sm d-flex flex-column align-items-center me-2`}
                                                                                                style={{
                                                                                                    width: '85px',
                                                                                                    minWidth: '85px',
                                                                                                    height: '100px',
                                                                                                    border: catId === ele?.category_id_ids ? '2px solid #FF7401' : '1px solid #ccc',
                                                                                                }}
                                                                                            >
                                                                                                <img
                                                                                                    src={ele?.category_image_url_chr}
                                                                                                    alt={ele?.category_display_name_chr}
                                                                                                    style={{ width: '50px', height: '50px', objectFit: 'contain' }}
                                                                                                />

                                                                                                <span className='fs-7 text-black font-w600 mt-2 text-center'>{ele.category_display_name_chr}</span>

                                                                                            </div>
                                                                                        )
                                                                                    )
                                                                                })

                                                                                }
                                                                            </> :
                                                                            <>
                                                                                <div className='d-flex justify-content-center align-items-center'>
                                                                                    <span className='text-black font-w500'>{`No Category Found`}</span>
                                                                                </div>
                                                                            </>
                                                                        }
                                                                    </div>
                                                                </div>

                                                                {categoryErr &&
                                                                    <div className='col-12 px-0'>
                                                                        <span className='text-danger font-w500'>{`Please select a device category`}</span>
                                                                    </div>
                                                                }


                                                                {productTypeList.length > 0 &&
                                                                    <>
                                                                        <div className='col-12 px-0'>
                                                                            <span className='text-black font-w600'>{`Select the ${objectCategoryName} Device Type`}</span>
                                                                        </div>

                                                                        <div className='col-12 px-0 mt-2'>
                                                                            <div className='d-flex align-items-center overflow-auto pb-2'>
                                                                                {productTypeResp ?
                                                                                    <>
                                                                                        {[...Array(4)].map((ele, ind) => {
                                                                                            return (
                                                                                                <div
                                                                                                    key={ind}
                                                                                                    className={`rounded-2 shadow-sm d-flex flex-column align-items-center me-2`}
                                                                                                    style={{
                                                                                                        width: '85px',
                                                                                                        minWidth: '85px',
                                                                                                        height: '100px',
                                                                                                        border: '1px solid #ccc',

                                                                                                    }}
                                                                                                >
                                                                                                    <SkeletonDivElement
                                                                                                        height={"100%"}
                                                                                                        borderRadius={'10px'}
                                                                                                        // rows={6}
                                                                                                        marginBottom='0px'
                                                                                                    />
                                                                                                </div>

                                                                                            )
                                                                                        })}
                                                                                    </> :
                                                                                    <>
                                                                                        {productTypeList.length > 0 ?
                                                                                            <>
                                                                                                {productTypeList.map((ele, ind) => {
                                                                                                    return (

                                                                                                        <div
                                                                                                            key={ind}
                                                                                                            onClick={(e) => {
                                                                                                                e.stopPropagation();
                                                                                                                handleSetProductType(ele);
                                                                                                                setProductTypeDetected(getProductTypeDisplayName(ele));
                                                                                                            }}
                                                                                                            className={`cursor-pointer p-2 rounded-2 shadow-sm d-flex flex-column align-items-center me-2`}
                                                                                                            style={{
                                                                                                                width: '85px',
                                                                                                                minWidth: '85px',
                                                                                                                height: '100px',
                                                                                                                border: prodTypeId === ele?.product_type_id_ids ? '2px solid #FF7401' : '1px solid #ccc',
                                                                                                            }}
                                                                                                        >
                                                                                                            <img
                                                                                                                src={ele?.product_type_image_url_chr ? ele?.product_type_image_url_chr : unavailbleServiceImg}
                                                                                                                alt={getProductTypeDisplayName(ele)}
                                                                                                                style={{ width: '50px', height: '50px', objectFit: 'contain' }}
                                                                                                            />

                                                                                                            <span className='fs-7 text-black font-w600 mt-2 text-center'>{getProductTypeDisplayName(ele)}</span>

                                                                                                        </div>

                                                                                                    )
                                                                                                })}
                                                                                            </> :
                                                                                            <>
                                                                                                <div className='d-flex justify-content-center align-items-center '>
                                                                                                    <span className=' text-black font-w500 '>{`No Device Found`}</span>
                                                                                                </div>
                                                                                            </>
                                                                                        }
                                                                                    </>
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                        {productTypeErr &&
                                                                            <div className='col-12 px-0'>
                                                                                <span className='text-danger font-w500'>{`Please select a device type`}</span>
                                                                            </div>
                                                                        }
                                                                    </>
                                                                }

                                                                <div className='col-12 px-0'>
                                                                    <div className="separator-custom my-3">
                                                                        <div className="line-custom me-3 bg-black"></div>
                                                                        <span className="text-custom fs-6 text-black font-w600">{`Optional`}</span>
                                                                        <div className="line-custom ms-3 bg-black"></div>
                                                                    </div>
                                                                </div>

                                                                <div className='col-12 px-0 d-flex mb-3'>
                                                                    <div className='d-flex align-items-center me-3'>
                                                                        <span className={`fs-6 text-primary font-w600 ${isEditingBrand ? 'mb-3' : ''}`}>{`Brand`}</span>
                                                                    </div>
                                                                    <div
                                                                        className='d-flex align-items-center justify-content-between  w-100'
                                                                        style={{
                                                                            borderBottom: !isEditingBrand ? '1px dashed orange' : '',
                                                                        }}
                                                                    >
                                                                        {isEditingBrand ?
                                                                            <InputField
                                                                                labelName={"Brand"}
                                                                                value={deviceBrandChr}
                                                                                onChange={handleDeviceBrandChr}
                                                                                onBlur={() => { }}
                                                                            /> :

                                                                            <span className='fs-5'>{`${deviceBrandChr}`}</span>
                                                                        }

                                                                        <div className={`d-flex align-items-center justify-content-center mx-2 ${isEditingBrand ? 'mb-3' : ''}`}>
                                                                            {isEditingBrand ?
                                                                                <div className="tooltipCustom">
                                                                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Save"}</span>
                                                                                    <span
                                                                                        className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                        onClick={(e) => { setIsEditingBrand(false) }}
                                                                                        style={{ height: '30px', width: '30px', }}
                                                                                    >
                                                                                        <i className="bi bi-check2-circle text-success" style={{ color: 'green', fontSize: '18px' }} />
                                                                                    </span>
                                                                                </div>
                                                                                :
                                                                                <div className="tooltipCustom">
                                                                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                                                                    <span
                                                                                        className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                        onClick={(e) => {
                                                                                            setIsEditingBrand(true);
                                                                                        }}
                                                                                        style={{ height: '30px', width: '30px', }}
                                                                                    >
                                                                                        <i className="bi bi-pencil" style={{ fontSize: '14px' }} />
                                                                                    </span>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className='col-12 px-0 d-flex mb-3'>
                                                                    <div className='d-flex align-items-center me-3'>
                                                                        <span className={`fs-6 text-primary font-w600 ${isEditingModel ? 'mb-3' : ''}`}>{`Model`}</span>
                                                                    </div>
                                                                    <div
                                                                        className='d-flex align-items-center justify-content-between  w-100'
                                                                        style={{
                                                                            borderBottom: !isEditingModel ? '1px dashed orange' : '',
                                                                        }}
                                                                    >
                                                                        {isEditingModel ?
                                                                            <InputField
                                                                                labelName={"Model"}
                                                                                value={modelNum}
                                                                                onChange={handleModelNum}
                                                                                onBlur={() => { }}
                                                                            /> :

                                                                            <span className='fs-5'>{`${modelNum}`}</span>
                                                                        }

                                                                        <div className={`d-flex align-items-center justify-content-center mx-2 ${isEditingModel ? 'mb-3' : ''}`}>
                                                                            {isEditingModel ?
                                                                                <div className="tooltipCustom">
                                                                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Save"}</span>
                                                                                    <span
                                                                                        className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                        onClick={(e) => { setIsEditingModel(false) }}
                                                                                        style={{ height: '30px', width: '30px', }}
                                                                                    >
                                                                                        <i className="bi bi-check2-circle text-success" style={{ color: 'green', fontSize: '18px' }} />
                                                                                    </span>
                                                                                </div>
                                                                                :
                                                                                <div className="tooltipCustom">
                                                                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                                                                    <span
                                                                                        className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                        onClick={(e) => {
                                                                                            setIsEditingModel(true);
                                                                                        }}
                                                                                        style={{ height: '30px', width: '30px', }}
                                                                                    >
                                                                                        <i className="bi bi-pencil" style={{ fontSize: '14px' }} />
                                                                                    </span>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className='col-12 px-0 d-flex justify-content-center align-items-center mb-2'>
                                                                    <PrimaryButton
                                                                        buttonName={"CONFIRM"}
                                                                        onClick={() => {
                                                                            handleSelectCategoryAndProctucType();
                                                                        }}
                                                                        isLoading={screenShotLoading}
                                                                        loadingMessage={"LOADING..."}
                                                                        className={""}
                                                                        style={{
                                                                            width: '200px',
                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                            fontWeight: '600',
                                                                        }}
                                                                    />
                                                                </div>


                                                            </div>
                                                        }
                                                    </div>
                                                    {window.innerWidth > 768 && <div className='col-md-3'></div>}
                                                </div>
                                            </> :
                                            (scanSteps == 2.2) ?
                                                <>
                                                    <div className='row mx-0 '>
                                                        {window.innerWidth > 768 && <div className='col-md-3'></div>}
                                                        <div
                                                            className={`col-md-6 d-flex position-relative px-3 py-1`}
                                                        >
                                                            <div className='row mx-0'>
                                                                <div className='col-12 px-0 mb-3 d-flex justify-content-center align-items-center'>
                                                                    <div
                                                                        className='d-flex flex-column justify-content-center align-items-center bg-light rounded-3'
                                                                        onClick={() => {
                                                                            handleOpenDoc();
                                                                            setImageAttachURL(attachedImage0);
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={attachedImage0}
                                                                            className=''
                                                                            alt="Error loading"
                                                                            style={{
                                                                                width: '90px',
                                                                                height: '110px',
                                                                                objectFit: 'contain'
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className='col-6  pe-1 d-flex mb-3 flex-column'>
                                                                    <div
                                                                        className='d-flex align-items-center me-2'
                                                                        style={{ width: '80px' }}
                                                                    >
                                                                        <span className={`fs-6 text-black font-w600 mb-2`}>{`Category`}</span>
                                                                    </div>
                                                                    <div
                                                                        className='d-flex align-items-center justify-content-between px-0 py-1 w-100 rounded-3 position-relative'
                                                                        style={{
                                                                            height: '45px',
                                                                            border: '2px solid rgba(0, 0, 0, 0.05)',
                                                                            backgroundColor: 'rgba(245, 247, 251, 1)',
                                                                        }}
                                                                    >
                                                                        <div className='d-flex align-items-center mx-2'>
                                                                            <img className='me-2' src={categoryObj?.category_image_url_chr} alt="Error loading" style={{ width: '30px', height: '30px', objectFit: 'contain' }} />
                                                                            <span className='fs-5'>{`${categoryObj?.category_display_name_chr}`}</span>
                                                                        </div>


                                                                        <div className={`d-flex align-items-center justify-content-center mx-2`}>
                                                                            <div className="tooltipCustom">
                                                                                <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                                                                <span
                                                                                    className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center bg-light"
                                                                                    onClick={(e) => {
                                                                                        setToggleForSelectCategory(true);
                                                                                        setToggleForSelectProductType(false);
                                                                                    }}
                                                                                    style={{ height: '30px', width: '30px', }}
                                                                                >
                                                                                    <i className="bi bi-pencil" style={{ fontSize: '14px' }} />
                                                                                </span>
                                                                            </div>
                                                                        </div>

                                                                        {toggleForSelectCategory &&
                                                                            <div
                                                                                className={`position-absolute rounded-2 shadow border p-2 bg-white`}
                                                                                style={{
                                                                                    top: '45px',
                                                                                    zIndex: '10',
                                                                                    width: 'max-content',
                                                                                }}
                                                                            >
                                                                                <div className='d-flex justify-content-between align-items-center py-2 border-bottom'>
                                                                                    <span className=' text-black font-w600'>{`Select Category Name`}</span>

                                                                                    <div className={`d-flex align-items-center justify-content-center mx-2`}>
                                                                                        <div className="tooltipCustom">
                                                                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Close"}</span>
                                                                                            <span
                                                                                                className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center bg-light"
                                                                                                onClick={(e) => {
                                                                                                    setToggleForSelectCategory(false);
                                                                                                }}
                                                                                                style={{ height: '30px', width: '30px', }}
                                                                                            >
                                                                                                <i className="bi bi-x-lg" style={{ fontSize: '14px' }} />
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {catArr.length > 0 ?
                                                                                    <>
                                                                                        {catArr.map((ele, ind) => {
                                                                                            return (
                                                                                                <>
                                                                                                    <div
                                                                                                        key={ind}
                                                                                                        className={`d-flex  align-items-center py-2 ${ind === catArr.length - 1 ? '' : 'border-bottom'} cursor-pointer overlay-action-btn`}
                                                                                                        onClick={() => {
                                                                                                            handleSetCatId(ele);
                                                                                                            setParticularID(ind);
                                                                                                            // setIsCustomResMsg(true);
                                                                                                            setToggleForSelectCategory(false);
                                                                                                        }}
                                                                                                        style={{
                                                                                                            pointerEvents: catId === ele?.category_id_ids ? "none" : "auto",
                                                                                                            opacity: catId === ele?.category_id_ids ? "0.7" : '1',
                                                                                                        }}
                                                                                                    >
                                                                                                        <input
                                                                                                            className="form-check-input me-2"
                                                                                                            style={{ display: 'inline-block' }}
                                                                                                            name="selectCard"
                                                                                                            type="radio"
                                                                                                            value={`${ele?.category_id_ids}`}
                                                                                                            onChange={(e) => { }}
                                                                                                            checked={catId === ele?.category_id_ids}
                                                                                                        />
                                                                                                        <img className='me-2' src={ele?.category_image_url_chr} alt="Error loading" style={{ width: '30px', height: '30px', objectFit: 'contain' }} />
                                                                                                        <span className='fs-5 text-black'>{`${ele?.category_display_name_chr}`}</span>
                                                                                                    </div>
                                                                                                </>
                                                                                            )
                                                                                        })}
                                                                                    </> :
                                                                                    <>
                                                                                        <div className='d-flex justify-content-between align-items-center mb-2'>
                                                                                            <span className=' text-black font-w500'>{`No Categories Found`}</span>
                                                                                        </div>
                                                                                    </>
                                                                                }



                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <div className='col-6 ps-1 d-flex mb-3 flex-column'>
                                                                    <div
                                                                        className='d-flex align-items-center me-2'
                                                                        style={{ width: '80px' }}
                                                                    >
                                                                        <span className={`fs-6 text-black font-w600 mb-2`}>{`Device`}</span>
                                                                    </div>
                                                                    <div
                                                                        className='d-flex align-items-center justify-content-between px-0 py-1 w-100 rounded-3 position-relative'
                                                                        style={{
                                                                            height: '45px',
                                                                            border: '2px solid rgba(0, 0, 0, 0.05)',
                                                                            backgroundColor: 'rgba(245, 247, 251, 1)',
                                                                        }}
                                                                    >
                                                                        <div className='d-flex align-items-center mx-2'>
                                                                            {Object.keys(productTypeObj).length !== 0 && <>
                                                                                <img className='me-2' src={productTypeObj?.product_type_image_url_chr} alt="Error loading" style={{ width: '30px', height: '30px', objectFit: 'contain' }} />
                                                                                <span className='fs-5'>{getProductTypeDisplayName(productTypeObj)}</span>
                                                                            </>}
                                                                        </div>

                                                                        <div className={`d-flex align-items-center justify-content-center mx-2`}>
                                                                            <div className="tooltipCustom">
                                                                                <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                                                                <span
                                                                                    className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center bg-light"
                                                                                    onClick={(e) => {
                                                                                        setToggleForSelectProductType(true);
                                                                                        setToggleForSelectCategory(false);
                                                                                    }}
                                                                                    style={{ height: '30px', width: '30px', }}
                                                                                >
                                                                                    <i className="bi bi-pencil" style={{ fontSize: '14px' }} />
                                                                                </span>
                                                                            </div>
                                                                        </div>

                                                                        {toggleForSelectProductType &&
                                                                            <div
                                                                                className={`position-absolute w-100 rounded-2 shadow border p-2 bg-white`}
                                                                                style={{
                                                                                    top: '45px',
                                                                                    zIndex: '10',
                                                                                }}
                                                                            >
                                                                                <div className='d-flex justify-content-between align-items-center py-2 border-bottom'>
                                                                                    <span className=' text-black font-w600'>{`Select Device Name`}</span>

                                                                                    <div className={`d-flex align-items-center justify-content-center mx-2`}>
                                                                                        <div className="tooltipCustom">
                                                                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Close"}</span>
                                                                                            <span
                                                                                                className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center bg-light"
                                                                                                onClick={(e) => {
                                                                                                    setToggleForSelectProductType(false);

                                                                                                }}
                                                                                                style={{ height: '30px', width: '30px', }}
                                                                                            >
                                                                                                <i className="bi bi-x-lg" style={{ fontSize: '14px' }} />
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {productTypeResp ?
                                                                                    <>
                                                                                        {[...Array(4)].map((elem, ind) => {
                                                                                            <div
                                                                                                key={ind}
                                                                                                className={`d-flex  align-items-center py-2 ${ind === productTypeList.length - 1 ? '' : 'border-bottom'} `}
                                                                                                style={{
                                                                                                    height: '30px',
                                                                                                    width: '100%',
                                                                                                }}
                                                                                            >
                                                                                                <SkeletonDivElement
                                                                                                    height={"100%"}
                                                                                                    width={"100%"}
                                                                                                    borderRadius={'10px'}
                                                                                                    // rows={6}
                                                                                                    marginBottom='0px'
                                                                                                />
                                                                                            </div>
                                                                                        })}
                                                                                    </> :
                                                                                    <>
                                                                                        {productTypeList.length > 0 ?
                                                                                            <>
                                                                                                {productTypeList.map((ele, ind) => {
                                                                                                    return (
                                                                                                        <>
                                                                                                            <div
                                                                                                                key={ind}
                                                                                                                className={`d-flex  align-items-center py-2 ${ind === catArr.length - 1 ? '' : 'border-bottom'} cursor-pointer overlay-action-btn`}
                                                                                                                onClick={(e) => {
                                                                                                                    e.stopPropagation();
                                                                                                                    handleSetProductType(ele);
                                                                                                                    setProductTypeDetected(getProductTypeDisplayName(ele));
                                                                                                                    setToggleForSelectProductType(false);
                                                                                                                }}
                                                                                                                style={{
                                                                                                                    pointerEvents: prodTypeId === ele?.product_type_id_ids ? "none" : "auto",
                                                                                                                    opacity: prodTypeId === ele?.product_type_id_ids ? "0.7" : '1',
                                                                                                                }}
                                                                                                            >
                                                                                                                <input
                                                                                                                    className="form-check-input me-2"
                                                                                                                    style={{ display: 'inline-block' }}
                                                                                                                    name="selectCard"
                                                                                                                    type="radio"
                                                                                                                    value={`${ele?.product_type_id_ids}`}
                                                                                                                    onChange={(e) => { }}
                                                                                                                    checked={prodTypeId === ele?.product_type_id_ids}
                                                                                                                />
                                                                                                                <img className='me-2' src={ele?.product_type_image_url_chr ? ele?.product_type_image_url_chr : unavailbleServiceImg} alt={ele?.product_type_name_ch} style={{ width: '30px', height: '30px', objectFit: 'contain' }} />
                                                                                                                <span className='fs-5 text-black'>{getProductTypeDisplayName(ele)}</span>
                                                                                                            </div>
                                                                                                        </>
                                                                                                    )
                                                                                                })}
                                                                                            </> :
                                                                                            <>
                                                                                                <div className='d-flex justify-content-between align-items-center mb-2'>
                                                                                                    <span className=' text-black font-w500'>{`No Device Found`}</span>
                                                                                                </div>
                                                                                            </>
                                                                                        }
                                                                                    </>
                                                                                }
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>

                                                                {deviceBrandChr &&
                                                                    <div className='col-12 px-0 d-flex mb-3'>
                                                                        <div
                                                                            className='d-flex align-items-center me-2'
                                                                            style={{ width: '80px' }}
                                                                        >
                                                                            <span className={`fs-6 text-black font-w600 `}>{`Brand`}</span>
                                                                        </div>
                                                                        <div
                                                                            className='d-flex align-items-center justify-content-between px-2 py-1 w-100 rounded-3'
                                                                            style={{
                                                                                height: '45px',
                                                                                border: '2px solid rgba(0, 0, 0, 0.05)',
                                                                                backgroundColor: 'rgba(245, 247, 251, 1)',
                                                                            }}
                                                                        >
                                                                            <div className='d-flex align-items-center'>
                                                                                <span className='fs-5'>{`${deviceBrandChr}`}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }

                                                                <div className='col-12 px-0 d-flex mb-3'>
                                                                    <div className='d-flex  flex-column w-100 '
                                                                        style={{

                                                                        }}
                                                                    >
                                                                        <span className='fs-6 font-w600 text-black pb-1'>{`Image Summary:`}</span>

                                                                        <span
                                                                            className='fs-6 font-w500 text-black px-2 py-2 rounded-3'
                                                                            style={{
                                                                                whiteSpace: 'pre-line',
                                                                                border: '2px solid rgba(0, 0, 0, 0.05)',
                                                                                backgroundColor: 'rgba(245, 247, 251, 1)',
                                                                            }}
                                                                        >
                                                                            {`${predictedObjectDetails?.predicted_object_info?.recognized_image_summary || 'Unable to provide image summary here'}`}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                <div className='col-12 px-0 d-flex mb-3 align-items-center justify-content-center'>
                                                                    <span
                                                                        className='terms-condition-link text-decoration-underline text-primary'
                                                                        onClick={() => {
                                                                            setImgSrc(null);
                                                                            setScanSteps(1.1);
                                                                            getCameraStream();
                                                                            deleteAttachedImage0();
                                                                            deleteAttachedImage1();
                                                                            deleteAttachedImage2();

                                                                            setCategoryObj({});
                                                                            // setProductNameForTicket('');
                                                                            setCatId('');
                                                                            // setBreadCatName(ele.category_name_chr + " >> ");
                                                                            setObjectCategoryName('');
                                                                            setBreadCatButtonName('');

                                                                            setProductTypeObj({});
                                                                            setProdTypeId('');
                                                                            setProductNameForTicket('');
                                                                        }}
                                                                    >
                                                                        {`Rescan The Device`}
                                                                    </span>
                                                                </div>



                                                                <div className='col-12 px-0 scan-verify-actions'>
                                                                    <PrimaryButton
                                                                        buttonName={"EDIT INFO"}
                                                                        onClick={() => {
                                                                            setScanSteps(2.1);
                                                                        }}
                                                                        isLoading={false}
                                                                        loadingMessage={"Saving..."}
                                                                        className={"scan-verify-actions__edit"}
                                                                        style={{
                                                                            width: '100%',
                                                                            maxWidth: '340px',
                                                                            fontSize: window.innerWidth > 768 ? '1.05rem' : '1rem',
                                                                            padding: '14px 20px',
                                                                            background: 'white',
                                                                            border: '2px solid rgba(79, 93, 116, 1)',
                                                                            fontWeight: '700',
                                                                            color: 'black',
                                                                        }}
                                                                    />

                                                                    <PrimaryButton
                                                                        buttonName={"LOOKS RIGHT"}
                                                                        onClick={(e) => {
                                                                            setScanSteps(3);
                                                                        }}
                                                                        isLoading={false}
                                                                        loadingMessage={"Saving..."}
                                                                        className={"scan-verify-actions__confirm"}
                                                                        style={{
                                                                            width: '100%',
                                                                            maxWidth: '340px',
                                                                            fontSize: window.innerWidth > 768 ? '1.15rem' : '1.1rem',
                                                                            padding: '16px 22px',
                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                            fontWeight: '700',
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {window.innerWidth > 768 && <div className='col-md-3'></div>}
                                                    </div>
                                                </> :
                                                (scanSteps == 3) ?
                                                    <>
                                                        <div className='row mx-0 '>
                                                            {window.innerWidth > 768 && <div className='col-md-3'></div>}
                                                            <div
                                                                className={`col-md-6 d-flexposition-relative px-3 py-1`}
                                                            >
                                                                <div className='row mx-0'>
                                                                    <div className='row mx-0 px-2 py-3 bg-white shadow-sm mb-3 rounded-2'>
                                                                        <div className='col-12 px-0 mb-4 d-flex justify-content-center align-items-center position-relative'>

                                                                            <div className='d-flex align-items-center justify-content-center w-100 overflow-auto'>
                                                                                {attachedImage0 !== null &&
                                                                                    <div
                                                                                        className='d-flex flex-column justify-content-center align-items-center bg-light rounded-3 me-2'
                                                                                        onClick={() => {
                                                                                            handleOpenDoc();
                                                                                            setImageAttachURL(attachedImage0);
                                                                                        }}
                                                                                    >
                                                                                        <img
                                                                                            src={attachedImage0}
                                                                                            className=''
                                                                                            alt="Error loading"
                                                                                            style={{
                                                                                                width: '90px',
                                                                                                height: '110px',
                                                                                                objectFit: 'contain'
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                }

                                                                                {attachedImage1 !== null &&
                                                                                    <div
                                                                                        className='d-flex flex-column justify-content-center align-items-center bg-light rounded-3 me-2 overflow-hidden position-relative'
                                                                                        onClick={() => {
                                                                                            handleOpenDoc();
                                                                                            setImageAttachURL(attachedImage1);
                                                                                        }}
                                                                                    >
                                                                                        <span
                                                                                            className='position-absolute cursor-pointer rounded-circle text-danger d-flex justify-content-center align-items-center bg-white text-black'
                                                                                            style={{ top: '3px', right: '3px', border: '1px solid black', width: '25px', height: '25px', zIndex: '2' }}
                                                                                            onClick={(e) => {
                                                                                                e.preventDefault();
                                                                                                e?.stopPropagation();
                                                                                                deleteAttachedImage1()
                                                                                            }}
                                                                                        >
                                                                                            <i className="bi bi-x-lg"></i>
                                                                                        </span>
                                                                                        <img
                                                                                            src={attachedImage1}
                                                                                            className=''
                                                                                            alt="Error loading"
                                                                                            style={{
                                                                                                width: '90px',
                                                                                                height: '110px',
                                                                                                objectFit: 'contain'
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                }

                                                                                {attachedImage2 !== null &&
                                                                                    <div
                                                                                        className='d-flex flex-column justify-content-center align-items-center bg-light rounded-3 overflow-hidden position-relative'
                                                                                        onClick={() => {
                                                                                            handleOpenDoc();
                                                                                            setImageAttachURL(attachedImage2);
                                                                                        }}
                                                                                    >
                                                                                        <span
                                                                                            className='position-absolute cursor-pointer rounded-circle text-danger d-flex justify-content-center align-items-center bg-white text-black'
                                                                                            style={{ top: '3px', right: '3px', border: '1px solid black', width: '25px', height: '25px', zIndex: '2' }}
                                                                                            onClick={(e) => {
                                                                                                e.preventDefault();
                                                                                                e?.stopPropagation();
                                                                                                deleteAttachedImage2()
                                                                                            }}
                                                                                        >
                                                                                            <i className="bi bi-x-lg"></i>
                                                                                        </span>
                                                                                        <img
                                                                                            src={attachedImage2}
                                                                                            className=''
                                                                                            alt="Error loading"
                                                                                            style={{
                                                                                                width: '90px',
                                                                                                height: '110px',
                                                                                                objectFit: 'contain'
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                }
                                                                            </div>


                                                                            <div
                                                                                className='position-absolute'
                                                                                style={{
                                                                                    right: '0px'
                                                                                }}
                                                                            >
                                                                                {attachedImage0 !== null && attachedImage1 == null &&
                                                                                    <div
                                                                                        className='rounded-2 d-flex flex-column justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                        style={{
                                                                                            border: '2px dashed rgba(149, 147, 144, 0.4)',
                                                                                            height: '110px',
                                                                                            width: '53px',
                                                                                            backgroundColor: "rgb(215 225 243)",
                                                                                            // opacity: attachedImage0 !== null || attachedImage1 !== null || attachedImage2 !== null ? '1' : '0.5'
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            if (attachedImage0 == null || attachedImage1 == null || attachedImage2 == null) {
                                                                                                // getCameraStream();
                                                                                                // setToggleForAddImage(true);
                                                                                                // setToggleForCameraActions(1);

                                                                                                handleOpenModalAddPhoto();
                                                                                            } else {
                                                                                                setUploadImageLimit(true);
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <span>
                                                                                            <i className="bi bi-plus-circle fs-4"></i>
                                                                                        </span>
                                                                                        <span className='font-w600 fs-7  text-center'>
                                                                                            {`Add Image`}
                                                                                        </span>
                                                                                    </div>
                                                                                }

                                                                                {attachedImage0 !== null && attachedImage1 !== null && attachedImage2 == null &&
                                                                                    <div
                                                                                        className='rounded-2 d-flex flex-column justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                        style={{
                                                                                            border: '2px dashed rgba(149, 147, 144, 0.4)',
                                                                                            height: '110px',
                                                                                            width: '53px',
                                                                                            backgroundColor: "rgb(215 225 243)",
                                                                                            // opacity: attachedImage0 !== null || attachedImage1 !== null || attachedImage2 !== null ? '1' : '0.5'
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            if (attachedImage0 == null || attachedImage1 == null || attachedImage2 == null) {
                                                                                                // getCameraStream();
                                                                                                // setToggleForAddImage(true);
                                                                                                // setToggleForCameraActions(1);

                                                                                                handleOpenModalAddPhoto();
                                                                                            } else {
                                                                                                setUploadImageLimit(true);
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <span>
                                                                                            <i className="bi bi-plus-circle fs-4"></i>
                                                                                        </span>
                                                                                        <span className='font-w600 fs-7 text-center'>
                                                                                            {`Add Image`}
                                                                                        </span>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-12 px-0 d-flex justify-content-center align-items-center mb-4 scan-user-notes-field">
                                                                            <TextArea
                                                                                labelName={"Notes"}
                                                                                placeholder={"Add your notes here..."}
                                                                                value={description}
                                                                                onChange={handleDescription}
                                                                                onBlur={() => { }}
                                                                            />
                                                                        </div>
                                                                    </div>




                                                                    <div className='col-12 px-0 d-flex justify-content-center align-items-center mb-2'>
                                                                        <PrimaryButton
                                                                            buttonName={"I'M READY TO CONNECT"}
                                                                            onClick={(e) => {
                                                                                // Payments are currenlty disabled for now
                                                                                if (paymentGatewayFlag && false) {
                                                                                    // setPaymentModal(true)
                                                                                    // handleOpenPaymentModalTrigger();
                                                                                } else {
                                                                                    submitFeedback();
                                                                                }
                                                                            }}
                                                                            isLoading={false}
                                                                            loadingMessage={"Saving..."}
                                                                            className={""}
                                                                            style={{
                                                                                width: '100%',
                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                fontWeight: '600',
                                                                            }}
                                                                        />
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            {window.innerWidth > 768 && <div className='col-md-3'></div>}
                                                        </div>
                                                    </> :
                                                    (scanSteps == 4) ?
                                                        <>
                                                            <div className='row mx-0 '>
                                                                {window.innerWidth > 768 && <div className='col-md-3'></div>}
                                                                <div
                                                                    className={`col-md-6 d-flex position-relative px-3 py-1`}
                                                                >
                                                                    <div className='row mx-0'>
                                                                        <div className='row mx-0 mb-3'>
                                                                            <div className='col-12 px-0 d-flex align-items-center mb-3'>
                                                                                <div className='d-flex justify-content-center align-items-center' style={{ width: '73px', height: '60px', background: '' }}>
                                                                                    <div className='rounded-2 h-100 w-100 d-flex justify-content-center align-items-center' style={{ background: 'rgb(255 224 183)', color: 'rgb(238, 123, 61)' }}>
                                                                                        <FiMessageCircle style={{ fontSize: '30px' }} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-12 px-0 d-flex justify-content-center align-items-center mb-5 flex-column">
                                                                                <span className='text-center text-black font-w600 fs-3'>
                                                                                    {`Oh snap! Our pros are helping your neighbors.`}
                                                                                </span>
                                                                                <span className='text-center text-black fs-5'>
                                                                                    {`We'll message you as soon as one is available.`}
                                                                                </span>
                                                                            </div>

                                                                            <div className='col-12 p-2 rounded-2 bg-white'>
                                                                                <div className="row d-flex justify-content-between mt-2">
                                                                                    <div className="col-12">
                                                                                        <InputField
                                                                                            labelName={lblFirstName}
                                                                                            value={firstName}
                                                                                            onChange={handleFirstName}
                                                                                            errorOccured={isFirstNameError}
                                                                                            errorMeesage={errorFirstNameMsg}
                                                                                            onBlur={() => { }}
                                                                                            isRequired={true}
                                                                                            autoF={true}
                                                                                        />
                                                                                    </div>
                                                                                </div>

                                                                                <div className="row mb-2">
                                                                                    <EmailPhoneCombine
                                                                                        isEnteringNumber={isPhone}
                                                                                        setIsEnteringNumber={setIsPhone}
                                                                                        handleInputValue={handleEmailPhone}
                                                                                        handleChangeCode={handleDropdownValue}
                                                                                        errorOccured={isEmailPhoneVal}
                                                                                        inputValue={emailPhoneValue}
                                                                                        handleOnBlur={handleEmailPhoneBlur}
                                                                                        defaultCodeValue={codeValue}
                                                                                        errorMessage={
                                                                                            // validEmail_OR_MobileNumberText
                                                                                            loginErrorMsg
                                                                                        }
                                                                                        isRequired={true}
                                                                                    />
                                                                                </div>

                                                                                {/* <div className='mb-2 mx-0 row'>
                                                                                    <div className='col-12 px-0'>
                                                                                        <TextArea
                                                                                            labelName={`Message`}
                                                                                            placeholder={`Message`}
                                                                                            value={messageText}
                                                                                            onChange={handleMessageText}
                                                                                            rows='3'
                                                                                            onBlur={() => { }}
                                                                                        />
                                                                                    </div>
                                                                                </div> */}
                                                                            </div>

                                                                            <div className='col-12 py-2 pt-4'>

                                                                                <div className='d-flex  mx-0 mb-3' style={{ height: '', background: '' }}>
                                                                                    <div className='d-flex justify-content-center align-items-center' style={{ width: '60px', background: '' }}>
                                                                                        <div className='rounded-2 h-100 w-100 d-flex justify-content-center align-items-center' style={{ background: '', color: '' }}>
                                                                                            <MdOutlineLock style={{ fontSize: '25px' }} />
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className=' ps-3' style={{ background: '' }}>
                                                                                        <div className="d-flex flex-column" >
                                                                                            {/* <span className='text-black font-w600 fs-4'>
                                                                                                {`Show us`}
                                                                                            </span> */}
                                                                                            <span className=''>
                                                                                                {`Just for this estimate. no marketing spam — unsubscribe anytime by replying STOP.`}
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        </div>

                                                                        {/* <div className='col-12 px-0 d-flex justify-content-center align-items-center mb-3 mt-5'>
                                                                            <span className='fs-4'>
                                                                                {`Start with an Estimate - Finish with a Fix`}
                                                                            </span>
                                                                        </div> */}





                                                                        <div className='col-12 px-0 d-flex justify-content-center align-items-center mb-2'>
                                                                            <PrimaryButton
                                                                                buttonName={"Submit"}
                                                                                onClick={(e) => {
                                                                                    handleSubmitGuestForm(e);
                                                                                }}
                                                                                needIcon={true}
                                                                                // isLoading={submitting}
                                                                                isLoading={loaderActive}

                                                                                loadingMessage={"Submitting..."}
                                                                                className={""}
                                                                                style={{
                                                                                    width: '100%',
                                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                    fontWeight: '600',
                                                                                }}
                                                                            />
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                                {window.innerWidth > 768 && <div className='col-md-3'></div>}
                                                            </div>
                                                        </> :
                                                        (scanSteps == 4.1) ?
                                                            <>
                                                                <div className='row mx-0 '>
                                                                    {window.innerWidth > 768 && <div className='col-md-3'></div>}
                                                                    <div
                                                                        className={`col-md-6 d-flex position-relative px-3 py-1`}
                                                                    >
                                                                        <div className='row mx-0'>
                                                                            <div className='row mx-0 mb-3'>
                                                                                <div className='col-12 px-0 d-flex align-items-center justify-content-center mb-3'>
                                                                                    <div className='d-flex justify-content-center align-items-center' style={{ width: '73px', height: '60px', background: '' }}>
                                                                                        <img
                                                                                            src={logo}
                                                                                            alt="Chilll"
                                                                                            className="scan-agent-link-intro__logo"
                                                                                        />
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-12 px-0 d-flex justify-content-center align-items-center mb-5 flex-column">
                                                                                    <span className='text-center text-black font-w600 fs-3'>
                                                                                        {`Verification Code`}
                                                                                    </span>

                                                                                </div>

                                                                                <div className="row mx-0">
                                                                                    <div className="col-12 px-0">

                                                                                        <div className="row mx-0 mb-1">
                                                                                            <div className="col-12 px-0 d-flex align-items-center justify-content-center fs-6 text-black">
                                                                                                <span className="text-center">{`We sent the verification code to`}</span>
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* <div className="row mx-0 mb-3">
                                                    <div className="col-12 px-0 d-flex align-items-center justify-content-center fs-5 text-black font-w600">
                                                      <img src={acceptServiceImg} alt="service" style={{ width: "40px", height: "52px" }} />
                                                    </div>
                                                  </div> */}

                                                                                        <div className="row mx-0 mb-4">
                                                                                            <div className="col-12 px-0 d-flex align-items-center justify-content-center fs-5 text-black font-w600">
                                                                                                <span className="text-center">
                                                                                                    {/* {`Leave your info and we'll follow up. Email or phone is required.`} */}
                                                                                                    {emailPhoneValue}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>

                                                                                        <form
                                                                                            onSubmit={handleActivateUser}
                                                                                            autoComplete={false}
                                                                                            className='p-3 rounded-2 shadow-sm bg-white'
                                                                                        >
                                                                                            <div className="row">
                                                                                                <InputField
                                                                                                    labelName={hintEnterValidationCode}
                                                                                                    placeholderName={hintEnterValidationCode}
                                                                                                    value={recievedCodeValue}
                                                                                                    onChange={handleValidateCode}
                                                                                                    errorOccured={isCodeError}
                                                                                                    errorMeesage={"Invalid code"}
                                                                                                    onBlur={() => { }}
                                                                                                />
                                                                                            </div>

                                                                                            <PrimaryButton
                                                                                                buttonName={btnVerify}
                                                                                                type={"submit"}
                                                                                                onClick={handleActivateUser}
                                                                                                isLoading={loaderActive}
                                                                                                loadingMessage={"Loading..."}
                                                                                                style={{
                                                                                                    width: "100%",
                                                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                }}
                                                                                            />
                                                                                        </form>


                                                                                        {resendCodeCheck && <div className="row mt-3  text-center">
                                                                                            <span>
                                                                                                {" "}
                                                                                                Didn't receive the code? You can request a new code <br></br>to be
                                                                                                sent in 00:
                                                                                                {resendCodeTimer > 9 ? resendCodeTimer : "0" + resendCodeTimer}{" "}
                                                                                            </span>
                                                                                        </div>}
                                                                                        <div className="row mt-3">
                                                                                            <div className=" d-flex justify-content-center">
                                                                                                <span
                                                                                                    onClick={resendCodeActivation}
                                                                                                    style={{
                                                                                                        color: "orange",
                                                                                                        fontWeight: "700",
                                                                                                        pointerEvents: resendCodeCheck ? "none" : "auto",
                                                                                                        opacity: resendCodeCheck ? "0.5" : "1",
                                                                                                        cursor: "pointer",
                                                                                                    }}>
                                                                                                    {btnResendCode}

                                                                                                </span>
                                                                                            </div>
                                                                                        </div>

                                                                                    </div>
                                                                                </div>


                                                                            </div>

                                                                            {/* <div className='col-12 px-0 d-flex justify-content-center align-items-center mb-3 mt-5'>
                                                                            <span className='fs-4'>
                                                                                {`Start with an Estimate - Finish with a Fix`}
                                                                            </span>
                                                                        </div> */}
                                                                        </div>
                                                                    </div>
                                                                    {window.innerWidth > 768 && <div className='col-md-3'></div>}
                                                                </div>
                                                            </> :
                                                            (scanSteps == 5) ?
                                                                <>
                                                                    <div className='row mx-0 '>
                                                                        {window.innerWidth > 768 && <div className='col-md-3'></div>}
                                                                        <div
                                                                            className={`col-md-6 d-flex position-relative px-3 py-1`}
                                                                        >
                                                                            <div className='row mx-0'>
                                                                                <div className='row mx-0 mb-3'>
                                                                                    <div className="col-12 px-0 d-flex align-items-center justify-content-center my-2">
                                                                                        <div className='d-flex justify-content-center align-items-center rounded-circle' style={{ width: '80px', height: '80px', background: 'rgb(185 223 150)' }}>
                                                                                            <span className='d-flex align-items-center justify-content-center rounded-circle text-white' style={{ width: '40px', height: '40px', background: 'rgb(78, 148, 38)', fontSize: '20px' }}>
                                                                                                <FaCheck />
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-12 px-0 d-flex justify-content-center align-items-center mb-1 flex-column">
                                                                                        <span className='text-center text-black font-w600 fs-3'>
                                                                                            {`You’re all set, there!`}
                                                                                        </span>
                                                                                    </div>

                                                                                    <div className='col-12 px-0 d-flex justify-content-center align-items-center mb-4'>
                                                                                        <span className='fs-4 text-center'>
                                                                                            {`Your request is in the queue. Our estimate pros are helping other homeowners right now — we’ll message you the second one’s free.`}
                                                                                        </span>
                                                                                    </div>


                                                                                    <div className='col-12 p-3 mt-3 bg-white rounded-2 shadow-sm'>

                                                                                        <div className='mb-3'>
                                                                                            <span className=' font-w600 fs-4'>{`What happens next`}</span>
                                                                                        </div>

                                                                                        <div className='d-flex  mx-0 mb-3' style={{ height: '', background: '' }}>
                                                                                            <div className='d-flex justify-content-center align-items-center' style={{ width: '60px', background: '' }}>
                                                                                                <div
                                                                                                    className='rounded-circle text-white font-w600 fs-4 d-flex justify-content-center align-items-center text-white'
                                                                                                    style={{ background: 'rgb(240, 160, 58)', height: '35px', width: '35px' }}
                                                                                                >
                                                                                                    1
                                                                                                </div>
                                                                                            </div>

                                                                                            <div className=' ps-3' style={{ background: '' }}>
                                                                                                <div className="d-flex flex-column" >
                                                                                                    <span className='text-black font-w600 fs-4'>
                                                                                                        {`A pro reviews your photo`}
                                                                                                    </span>
                                                                                                    <span className=''>
                                                                                                        {`Real person, no rush, no upsell.`}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className='d-flex  mx-0 mb-3' style={{ height: '', background: '' }}>
                                                                                            <div className='d-flex justify-content-center align-items-center' style={{ width: '60px', background: '' }}>
                                                                                                <div
                                                                                                    className='rounded-circle text-white font-w600 fs-4 d-flex justify-content-center align-items-center text-white'
                                                                                                    style={{ background: 'rgb(240, 160, 58)', height: '35px', width: '35px' }}
                                                                                                >
                                                                                                    2
                                                                                                </div>
                                                                                            </div>

                                                                                            <div className=' ps-3' style={{ background: '' }}>
                                                                                                <div className="d-flex flex-column" >
                                                                                                    <span className='text-black font-w600 fs-4'>
                                                                                                        {`We message you when it’s ready`}
                                                                                                    </span>
                                                                                                    <span className=''>
                                                                                                        {`Usually within a few hours.`}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className='d-flex  mx-0 mb-3' style={{ height: '', background: '' }}>
                                                                                            <div className='d-flex justify-content-center align-items-center' style={{ width: '60px', background: '' }}>
                                                                                                <div
                                                                                                    className='rounded-circle text-white font-w600 fs-4 d-flex justify-content-center align-items-center text-white'
                                                                                                    style={{ background: 'rgb(240, 160, 58)', height: '35px', width: '35px' }}
                                                                                                >
                                                                                                    3
                                                                                                </div>
                                                                                            </div>

                                                                                            <div className=' ps-3' style={{ background: '' }}>
                                                                                                <div className="d-flex flex-column" >
                                                                                                    <span className='text-black font-w600 fs-4'>
                                                                                                        {`You choose how to fix it`}
                                                                                                    </span>
                                                                                                    <span className=''>
                                                                                                        {`DIY, guided, or a vetted local pro.`}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <div className='col-12 mb-3'>

                                                                                    <div
                                                                                        className='d-flex mx-0 py-2'
                                                                                        style={{ height: '', background: 'rgb(253, 241, 225)', border: '1px solid rgba(240, 160, 58, 0.3)' }}
                                                                                    >
                                                                                        <div className='d-flex justify-content-center align-items-center' style={{ width: '60px', background: '' }}>
                                                                                            <div className='rounded-2 h-100 w-100 d-flex justify-content-center align-items-center' style={{ background: '', color: 'rgb(240, 160, 58)' }}>
                                                                                                <PiBellRingingBold style={{ fontSize: '25px' }} />
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className=' ps-3' style={{ background: '' }}>
                                                                                            <div className="d-flex flex-column" >
                                                                                                {/* <span className='text-black font-w600 fs-4'>
                                                                                                {`Show us`}
                                                                                            </span> */}
                                                                                                <span className=''>
                                                                                                    {`Keep an eye on your sms text/email — no need to keep this page open.`}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                </div>

                                                                                {/* <div className='col-12 px-0 d-flex justify-content-center align-items-center mb-3 mt-5'>
                                                                                <span className='fs-4'>
                                                                                    {`Start with an Estimate - Finish with a Fix`}
                                                                                </span>
                                                                            </div> */}

                                                                                <div className='col-12 px-0 d-flex justify-content-center align-items-center mb-2'>
                                                                                    <PrimaryButton
                                                                                        buttonName={"Okay"}
                                                                                        onClick={(e) => {
                                                                                            navigate(`/login`, { replace: true });
                                                                                        }}
                                                                                        needIcon={true}
                                                                                        isLoading={false}
                                                                                        loadingMessage={"Saving..."}
                                                                                        className={""}
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                            fontWeight: '600',
                                                                                        }}
                                                                                    />
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                        {window.innerWidth > 768 && <div className='col-md-3'></div>}
                                                                    </div>
                                                                </> :
                                                                <></>
                            }

                        </div>
                    </> :
                    <>
                        <>
                            <div>
                                {/* <span onClick={() => { setToggleForAddImage(false); stopCameraStream(); }}>{`Back`}</span> */}
                                <div className='row mx-2 my-2'>
                                    <div className='col-12'>
                                        <span
                                            onClick={() => {
                                                setToggleForAddImage(false);
                                                stopCameraStream();
                                                setScanSteps(3);
                                            }}
                                            className="cursor-pointer px-3 py-2 text-black font-w600 overlay-action-btn rounded-3">
                                            <i className="bi bi-arrow-left me-2"></i> {`Back`}
                                        </span>
                                    </div>
                                </div>

                                <div className='row mx-0'>
                                    <div className='col-12 px-2 d-flex justify-content-center align-items-center'>
                                        <span className='text-black font-w600 fs-4 text-center'>{`Snap the image of device`}</span>
                                    </div>
                                </div>

                                {/* <div className='row mx-0 d-flex justify-content-center'>
                                    {cameraInitializedLoading && <>
                                        <Spinner size='xl' variant='primary' />
                                    </>}
                                </div> */}
                                <div className='row mx-0' style={{ minHeight: 'calc(100vh - 200px)' }}>
                                    {window.innerWidth > 768 && <div className='col-md-1'></div>}
                                    <div
                                        className={`col-md-10 d-flex justify-content-center align-items-center overflow-hidden ${!imgSrc && 'bg-light'} position-relative`}
                                        style={{ height: '65dvh' }}
                                    >
                                        {!imgSrc && <>
                                            {!isCameraAllowed &&
                                                <div
                                                    className='d-flex flex-column position-absolute  justify-content-center align-items-center w-100'
                                                    style={{
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate(-50%, -50%)",
                                                        zIndex: "1",
                                                    }}
                                                >
                                                    <span
                                                        className="fs-4 text-center text-black font-w600"
                                                    >
                                                        {"Camera access is blocked."}
                                                    </span>

                                                    <span
                                                        className=" fs-6 text-center font-w600"
                                                    >
                                                        {"Please enable camera access in your browser settings and refresh the page."}
                                                    </span>
                                                </div>
                                            }

                                            <video
                                                ref={videoRef}
                                                autoPlay
                                                playsInline
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                                                }}
                                            ></video>
                                            {/* <canvas
                                                ref={canvasVideoRef}
                                                style={{ display: 'none' }} // Hide canvas element
                                            ></canvas> */}
                                        </>}


                                        {imgSrc && (
                                            <div className='d-flex justify-content-center align-items-center' style={{}}>
                                                <ImageCropper imgSrc={imgSrc} canvasRef={canvasRef} setCrop={setCrop} />
                                            </div>
                                        )}


                                    </div>
                                    {window.innerWidth > 768 && <div className='col-md-1'></div>}

                                    <div className='row mx-0'>
                                        <div className='col-12 px-0 my-2 d-flex justify-content-center align-items-center'>

                                            {imgSrc ?
                                                <>
                                                    <PrimaryButton
                                                        buttonName={"RETAKE"}
                                                        onClick={() => { setImgSrc(null); getCameraStream(); }}
                                                        isLoading={false}
                                                        loadingMessage={"Saving..."}
                                                        className={"me-3"}
                                                        style={{
                                                            width: window.innerWidth > 768 ? '150px' : '125px',
                                                            fontSize: window.innerWidth > 768 ? '14px' : '10px',
                                                            background: 'rgba(79, 93, 116, 1)',
                                                            border: '2px solid rgba(79, 93, 116, 1)',
                                                            // boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                            fontWeight: '600',
                                                        }}
                                                    />

                                                    <PrimaryButton
                                                        buttonName={"CONTINUE"}
                                                        onClick={(e) => {
                                                            handleContinue(e);
                                                            setScanSteps(3);
                                                        }}
                                                        isLoading={false}
                                                        loadingMessage={"Saving..."}
                                                        className={""}
                                                        style={{
                                                            width: window.innerWidth > 768 ? '150px' : '125px',
                                                            fontSize: window.innerWidth > 768 ? '14px' : '10px',
                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                            fontWeight: '600',
                                                        }}
                                                    />
                                                </> :
                                                <>
                                                    {/* <div className='row mx-0'>
                                                    <div
                                                        className='col-12 '
                                                        style={{
                                                            pointerEvents: screenShotLoading ? "none" : "auto",
                                                            opacity: screenShotLoading ? "0.5" : "1",
                                                        }}
                                                    >
                                                    </div>
                                                </div> */}
                                                    <PrimaryButton
                                                        buttonName={"CAPTURE"}
                                                        onClick={() => {
                                                            capture();
                                                            // setScanSteps(1.2);
                                                        }}
                                                        isLoading={screenShotLoading}
                                                        loadingMessage={"LOADING..."}
                                                        className={""}
                                                        style={{
                                                            width: '200px',
                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                            fontWeight: '600',
                                                        }}
                                                    />
                                                </>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    </>
                }
            </div >

            {/* Modal for previewing the attached image preview */}
            {
                openDoc &&
                <ImagePreviewer
                    openDoc={openDoc}
                    handleCloseDoc={handleCloseDoc}
                    imageAttachURL={imageAttachURL}
                    notesMessage={discussionVal}

                // isNoteEdit={isNoteEdit}
                // onClick={handleUpdateProjectNotes}
                // buttonLoading={saveLoading}
                // setDiscussionVal={setDiscussionVal}
                />
            }


            {/* Modal for Add project photo */}
            <Modal
                className="fade"
                show={modalTriggerForAddPhoto}
                // onHide={handleClose}
                centered
                size='sm'
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => handleCloseModalAddPhoto()}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <>
                                <div className="row mx-0 mb-3">
                                    <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                        <span className="">{"Select from"}</span>
                                    </div>
                                </div>

                                <div className="row mx-0 mt-3 pb-2">
                                    <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                        <span className="fs-5 text-center">
                                            {"Select how you want to add photo"}
                                        </span>
                                    </div>
                                </div>

                                <div className="row mx-0 text-black mt-2">
                                    <div className="col-6 pe-2 font-w600 mb-2">
                                        <PrimaryButton
                                            onClick={(e) => {
                                                handleClickUploadPicture();
                                                // handleCloseModalAddPhoto();
                                            }}
                                            buttonName={"Gallery"}
                                            isLoading={imgUploadLoading}
                                            loadingMessage={'Loading...'}
                                            style={{
                                                width: "100%",
                                                backgroundColor: "white",
                                                border: "1px solid grey",
                                                color: "black",
                                                fontWeight: '600',
                                            }}
                                        />

                                        <input
                                            ref={uploadPicRef}
                                            onChange={(e) => {
                                                handleUploadPicture(e);
                                            }}
                                            on
                                            className="form-control"
                                            type="file"
                                            accept="image/*"
                                            hidden
                                        />
                                    </div>


                                    <div className="col-6 ps-2 font-w600 mb-2">

                                        <PrimaryButton
                                            onClick={(e) => {
                                                getCameraStream();
                                                setToggleForAddImage(true);
                                                // setToggleForCameraActions(1);

                                                handleCloseModalAddPhoto();
                                            }}
                                            isLoading={imgUploadLoading}
                                            loadingMessage={'Camera'}
                                            buttonName={"Camera"}
                                            style={{
                                                width: "100%",
                                                backgroundColor: "white",
                                                border: "1px solid grey",
                                                color: "black",
                                                fontWeight: '600',
                                            }}
                                        />


                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Modal for the service action after creating the service request */}
            <Modal className='fade' centered show={serviceActionModalTrigger}>
                <Modal.Body>
                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <>
                                {(serviceRequestModalTabs != 1 && serviceRequestModalTabs != 2 && serviceRequestModalTabs != 4) &&
                                    <div className='row mx-0 mb-3'>
                                        <div className='col-6 px-0 d-flex justify-content-start align-items-center'>
                                            {/* {toggleForDocuments === 2 && !documentId && */}
                                            <div
                                                className='cursor-pointer d-flex align-items-center text-hovered font-w600 fs-5'
                                                onClick={() => {
                                                    setServiceRequestModalTabs(1);
                                                }}
                                            >
                                                <span>
                                                    <i className='bi bi-arrow-left me-2'></i>
                                                </span>
                                                <span>
                                                    Back
                                                </span>
                                            </div>
                                            {/* } */}
                                        </div>

                                        <div className='col-6 px-0 d-flex justify-content-end'>
                                            <span
                                                onClick={() => {
                                                    setServiceRequestModalTabs(1);
                                                }}
                                                className='cursor-pointer fs-4 text-black text-hovered'
                                            >
                                                <i className="bi bi-x-lg"></i>
                                            </span>
                                        </div>
                                    </div>
                                }

                                {/* Selection tab for the service request actions */}
                                {serviceRequestModalTabs === 1 ? <>
                                    <div className='mx-0 row text-black mb-3'>
                                        <div className='col-12 font-w600 fs-3 px-0 text-center'>
                                            <span className='me-2'>
                                                <i className='bi bi-info-circle text-warning'></i>
                                            </span>
                                            <span>
                                                {"No Pro is available now"}
                                            </span>
                                        </div>
                                        {/* <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                                        <span onClick={() => handleCloseServiceActionModal()} className='cursor-pointer fs-4 text-black text-hovered'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div> */}
                                    </div>

                                    <div className='mx-0 row mb-3'>
                                        <div className='col-12 font-w500 fs-5 px-0 text-center'>
                                            <span>
                                                {`We will continue to search for a Pro and once one is available, we will connect you automatically so keep your smart device close. `}
                                            </span>
                                        </div>
                                    </div>

                                    <div className='mx-0 row mb-3'>
                                        <div className='col-12 font-w500 fs-5 px-0 text-center'>
                                            <span>
                                                {`You can also schedule or cancel the request.`}
                                            </span>
                                        </div>
                                    </div>

                                    <div className='row mb-3'>
                                        <div className='col-12 px-0'>
                                            {/* Service request options */}
                                            <div className='mx-0 row lh-lg cursor-pointer overlay-action-btn text-black' onClick={() => { setServiceRequestSelectedOption(`1`) }}>
                                                <div className='col-12 font-w500 fs-4 px-0 '>
                                                    <div className={`border-bottom mx-0 p-2 row `}>
                                                        <div className="align-items-cente col-2 d-flex px-0 justify-content-center">
                                                            <input
                                                                className="form-check-input d-flex"
                                                                type="radio"
                                                                name="avatar"
                                                                value={`1`}
                                                                onChange={(e) => setServiceRequestSelectedOption(`1`)}
                                                                checked={serviceRequestSelectedOption == `1`}
                                                            />
                                                        </div>

                                                        <div className={`align-items-cente col-10 d-flex px-0 ${serviceRequestSelectedOption == `1` ? "font-w600" : "font-w500"}`}>
                                                            <span>
                                                                {`Wait for a Pro`}
                                                            </span>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>

                                            <div className='mx-0 row lh-lg cursor-pointer overlay-action-btn text-black' onClick={() => { setServiceRequestSelectedOption(`2`) }}>
                                                <div className='col-12 font-w500 fs-4 px-0 '>
                                                    <div className={`border-bottom mx-0 p-2 row `}>
                                                        <div className="align-items-cente col-2 d-flex px-0 justify-content-center">
                                                            <input
                                                                className="form-check-input d-flex"
                                                                type="radio"
                                                                name="avatar"
                                                                value={`1`}
                                                                onChange={(e) => setServiceRequestSelectedOption(`2`)}
                                                                checked={serviceRequestSelectedOption == `2`}
                                                            />
                                                        </div>

                                                        <div className={`align-items-cente col-10 d-flex px-0 ${serviceRequestSelectedOption == `2` ? "font-w600" : "font-w500"}`}>
                                                            <span>
                                                                {`Schedule a Date & time`}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='mx-0 row lh-lg cursor-pointer overlay-action-btn text-black' onClick={() => { setServiceRequestSelectedOption(`3`) }}>
                                                <div className='col-12 font-w500 fs-4 px-0 '>
                                                    <div className={` mx-0 p-2 row `}>
                                                        <div className="align-items-cente col-2 d-flex px-0 justify-content-center">
                                                            <input
                                                                className="form-check-input d-flex"
                                                                type="radio"
                                                                name="avatar"
                                                                value={`3`}
                                                                onChange={(e) => setServiceRequestSelectedOption(`3`)}
                                                                checked={serviceRequestSelectedOption == `3`}
                                                            />
                                                        </div>

                                                        <div className={`align-items-cente col-10 d-flex px-0 ${serviceRequestSelectedOption == `3` ? "font-w600" : "font-w500"}`}>
                                                            <span>
                                                                {`Cancel Request`}
                                                            </span>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row mx-0 mt-2'>
                                        <div className='col-12 px-0'>
                                            <PrimaryButton
                                                onClick={() => {
                                                    // uploadProfessionalDocuments()
                                                    // handleSubmitServiceReqOption()
                                                    handleServiceRequestActions();
                                                }}
                                                buttonName={"PROCEED"}
                                                type="submit"
                                                loadingMessage="SUBMITTING..."
                                                isLoading={false}
                                                style={{
                                                    width: "100%",
                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                    border: '1px solid rgba(255, 154, 32, 1)',
                                                    fontWeight: '600',
                                                }}
                                            />
                                        </div>
                                    </div>
                                </> :
                                    // Waiting for Pro success message
                                    serviceRequestModalTabs === 2 ?
                                        <>
                                            <div className='mx-0 row text-black mb-3'>
                                                <div className='col-12 font-w600 fs-4 px-0 text-center'>
                                                    <img src={serviceImg} alt="" style={{ maxWidth: '150px' }} />
                                                </div>
                                            </div>

                                            <div className='mx-0 row text-black mb-3'>
                                                <div className='col-12 font-w600 fs-4 px-0 text-center'>
                                                    <span>
                                                        {"We will continue to search for a pro and will notify you when one is available."}
                                                    </span>
                                                </div>

                                            </div>

                                            <div className='row mx-0'>
                                                <div className='col-12 px-0'>
                                                    <PrimaryButton
                                                        onClick={() => {
                                                            handleCloseServiceActionModal();
                                                            navigate('/');
                                                        }}
                                                        buttonName={"OK"}
                                                        type="submit"
                                                        loadingMessage="SUBMITTING..."
                                                        isLoading={false}
                                                        style={{
                                                            width: "100%",
                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                            border: '1px solid rgba(255, 154, 32, 1)',
                                                            fontWeight: '600',
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </> :
                                        // Service request follow up
                                        serviceRequestModalTabs === 3 ?
                                            <>
                                                <div className='mx-0 row text-black mb-3'>
                                                    <div className='col-12 font-w600 fs-3 px-0 text-center'>
                                                        <span>
                                                            {"Service Request Follow-up"}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className='mx-0 row text-black mb-3'>
                                                    <div className="col-12  px-0 text-center">
                                                        <InputField
                                                            type="date"
                                                            labelName={"Date"}
                                                            placeholder={"Date"}
                                                            value={currentDate}
                                                            onChange={(e) => setCurrentDate(e.target.value)}
                                                            errorOccured={false}
                                                            errorMeesage={"Please enter date"}
                                                            onBlur={() => { }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className='mx-0 row text-black mb-3'>
                                                    <div className="col-12  px-0 text-center">
                                                        <SelectInputTimeSlot
                                                            labelName={'Best Time To Contact'}
                                                            onChange={(e) => updateTimeSlotFn(e)}
                                                            defaultValue={timeSlotID}
                                                            errorOccured={timeSlotCheck}
                                                            errorMessage={'select your preferred time slot'}
                                                            options={timeSlotArr}
                                                        />
                                                    </div>
                                                </div>

                                                <div className='row mx-0'>
                                                    <div className='col-12 px-0'>
                                                        <PrimaryButton
                                                            onClick={(e) => {
                                                                updateServiceRequestFn(e)
                                                            }}
                                                            buttonName={"SAVE PREFERENCES"}
                                                            type="submit"
                                                            loadingMessage="SAVING..."
                                                            isLoading={saveUpdateTicketLoading}
                                                            style={{
                                                                width: "100%",
                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                border: '1px solid rgba(255, 154, 32, 1)',
                                                                fontWeight: '600',
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </> :
                                            // Service request follow up success message
                                            serviceRequestModalTabs === 4 ?
                                                <>
                                                    <div className='mx-0 row text-black mb-3'>
                                                        <div className='col-12 font-w600 fs-4 px-0 text-center'>
                                                            <img src={serviceImg} alt="" style={{ maxWidth: '150px' }} />
                                                        </div>
                                                    </div>

                                                    <div className='mx-0 row text-black mb-3'>
                                                        <div className='col-12 font-w600 fs-4 px-0 text-center'>
                                                            <span>
                                                                {responceMsg || 'Service request details updated successfully.'}
                                                            </span>
                                                        </div>

                                                    </div>

                                                    <div className='row mx-0'>
                                                        <div className='col-12 px-0'>
                                                            <PrimaryButton
                                                                onClick={() => {
                                                                    handleCloseServiceActionModal();
                                                                    navigate('/');
                                                                }}
                                                                buttonName={"OK"}
                                                                type="submit"
                                                                loadingMessage="SUBMITTING..."
                                                                isLoading={false}
                                                                style={{
                                                                    width: "100%",
                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                    border: '1px solid rgba(255, 154, 32, 1)',
                                                                    fontWeight: '600',
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </> :
                                                // Cancel service request
                                                serviceRequestModalTabs === 5 ?
                                                    <>
                                                        <div className='mx-0 row text-black mb-3'>
                                                            <div className='col-12 font-w600 fs-3 px-0 text-center'>
                                                                <span>
                                                                    {"Cancel Service request"}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <div className='mx-0 row mb-3'>
                                                            <div className='col-12 font-w500 fs-5 px-0 text-center'>
                                                                <span>
                                                                    {`Are you sure you want to delete or save changes to this service request?`}
                                                                </span>
                                                            </div>
                                                        </div>


                                                        <div className='row mx-0'>
                                                            <div className='col-12 d-flex justify-content-center mt-4'>
                                                                <div
                                                                    className='row mx-0 w-100'
                                                                    style={{
                                                                        opacity: deleteServiceReqLoading || loadingForCancelRequest ? '0.6' : '1',
                                                                        pointerEvents: deleteServiceReqLoading || loadingForCancelRequest ? 'none' : 'auto',
                                                                    }}
                                                                >
                                                                    <div className='col-6 d-flex justify-content-center mb-3 pe-1'>
                                                                        <PrimaryButton
                                                                            onClick={() => { deleteServiceReqFunc() }}
                                                                            buttonName={"DELETE REQUEST"}
                                                                            loadingMessage={"DELETING..."}
                                                                            isLoading={deleteServiceReqLoading}
                                                                            style={{
                                                                                width: window.innerWidth > 768 ? '150px' : '125px',
                                                                                fontSize: window.innerWidth > 768 ? '14px' : '10px',
                                                                                background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                                                border: '2px solid rgba(240, 72, 72, 1)',
                                                                                boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                                                fontWeight: '600',
                                                                            }}
                                                                        />
                                                                    </div>

                                                                    <div className='col-6 d-flex justify-content-center mb-3 ps-1'>
                                                                        <PrimaryButton
                                                                            onClick={() => { cancelRequest() }}
                                                                            buttonName={"SAVE REQUEST"}
                                                                            loadingMessage={"SAVING..."}
                                                                            isLoading={loadingForCancelRequest}
                                                                            style={{
                                                                                width: window.innerWidth > 768 ? '150px' : '125px',
                                                                                fontSize: window.innerWidth > 768 ? '14px' : '10px',
                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                fontWeight: '600',
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </> :
                                                    // Cancel service request success message
                                                    serviceRequestModalTabs === 6 ?
                                                        <>
                                                            <div className='mx-0 row text-black mb-4'>
                                                                <div className='col-12 font-w600 fs-4 px-0 text-center'>
                                                                    <img src={logo} alt="" style={{ maxWidth: '125px' }} />
                                                                </div>
                                                            </div>

                                                            <div className='mx-0 row text-black mb-3'>
                                                                <div className='col-12 font-w600 fs-4 px-0 text-center'>
                                                                    <span>
                                                                        {responceMsg || 'Service request deleted successfully.'}
                                                                    </span>
                                                                </div>

                                                            </div>

                                                            <div className='row mx-0'>
                                                                <div className='col-12 px-0'>
                                                                    <PrimaryButton
                                                                        onClick={() => {
                                                                            handleCloseServiceActionModal();
                                                                            navigate('/');
                                                                        }}
                                                                        buttonName={"OK"}
                                                                        type="submit"
                                                                        loadingMessage="SUBMITTING..."
                                                                        isLoading={false}
                                                                        style={{
                                                                            width: "100%",
                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                            border: '1px solid rgba(255, 154, 32, 1)',
                                                                            fontWeight: '600',
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </> :
                                                        <></>
                                }
                            </>


                        </div>
                    </div >
                </Modal.Body >
            </Modal >


            {(backDropLoaderResp) &&
                <DummyBackdropLoader categoryObj={categoryObj} />
            }



            {
                backDropLoaderRejectedCase && (
                    <BackDropLoaderRejectedCase
                        categoryObj={categoryObj}
                        showUpdate={false}
                        openLoader={backDropLoaderRejectedCase}
                        descriptionVal={problemDescription}
                        modelNumVal={modelNum}
                        timeSlotArr={timeSlotArr}
                        communicationModeArr={comminicationModeArr}
                    />
                )
            }
            {
                backDropLoaderStatus && (
                    <BackDrop
                        categoryObj={categoryObj}
                        showUpdate={false}
                        openLoader={backDropLoaderStatus}
                        descriptionVal={problemDescription}
                        modelNumVal={modelNum}
                        timeSlotArr={timeSlotArr}
                        communicationModeArr={comminicationModeArr}
                    />
                )
            }
            {(errBackDropLoaderResp) && <ErrorBackdropLoader resMessage={responceMsg} />}
            {
                updateServiceRequestStatus && (
                    <UpdateServiceRequest
                        objectCategoryName={objectCategoryName}
                        descriptionVal={problemDescription}
                        modelNumVal={modelNum}
                        timeSlotArr={timeSlotArr}
                        communicationModeArr={comminicationModeArr}
                        attachedImg={attachedImage0}
                    />
                )
            }

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}
        </>
    )
}

export default Estimate;